import i18next from 'i18next';

export const kk: i18next.ResourceLanguage = {
	Account: {
		Account: 'Жеке кабинет',
		Email: 'Эл. пошта мекенжайы',
		Phone: 'Телефон нөмірі',
		'Please enter your phone number': 'Телефон нөміріңізді енгізіңіз',
		'Please enter your email': 'Эл. пошта мекенжайыңызды енгізіңіз',
		'Contact details are necessary for us to be able to pass on the latest flight information.':
			'Рейстер туралы соңғы ақпаратты алу үшін байланыс ақпараты қажет.',
		'Add login through your social network account':
			'Әлеуметтік желілердегі тіркелгі арқылы кіру мүмкіндігін қосыңыз',
		'I want to receive news and special offers': 'Мен жаңалықтар мен арнайы ұсыныстарды алғым келеді',
		'Load personal data according to the standard of GDPR': 'Жеке деректерді GDPR стандартына сәйкес жүктеп салу',
		Terms: 'Ережелер',
		'Delete my account': 'Тіркелгіні жою',
		'Are you sure?': 'Сенімдісіз бе?',
		'Are you sure you want to delete your account?': 'Тіркелгіні жойғыңыз келетініне сенімдісіз бе?',
		'Yes, Delete account': 'Иә, тіркелгіні жою',
		'Please enter a valid email': 'Эл. пошта мекенжайын тексеріңіз',
		'Please enter a valid phone': 'Телефон нөмірін тексеріңіз',
		'Confirmation code': 'Растау коды',
		'We sent verification code to new email': 'Жаңа эл. пошта мекенжайына растау кодын жібердік',
		'We sent verification code to the phone': 'Телефоныңызға растау кодын жібердік',
		'Didn\'t get the code?': 'Кодты алмадыңыз ба?',
		'Resend it': 'Қайта жіберу',
		Orders: 'Менің брондауларым',
		'Please confirm your email': 'Эл. пошта мекенжайыңызды растаңыз',
		'Please confirm your phone number': 'Телефон нөміріңізді растаңыз',
		Confirm: 'Растау',
		Save: 'Сақтау',
		Send: 'Жіберу',
		'Travel companions': 'Бағыты бір жолаушылар',
		Logout: 'Шығу',
		'Personal details': 'Тіркелгі',
		Settings: 'Параметрлер',
		'Incorrect card number or password': 'Карта нөмірі немесе құпиясөз қате',
		'Loyalty program': 'Бейілділік бағдарламасы',
		FFP: 'Бейілділік бағдарламасы',
		'Loyalty card number': 'Бейілділік картасының нөмірі',
		Password: 'Құпиясөз',
		'Client support': 'Көмек',
		No: 'Жоқ',
		'Log out': 'Шығу',
		'Phone is already in use by another account': 'Бұл телефон басқа тіркелгіде пайдаланылуда',
		'Email is already in use by another account': 'Бұл пошта басқа тіркелгіде пайдаланылуда',
		'Failed to fetch': 'Сұрауды орындау кезінде қате пайда болды',
		'Oops...': 'Ой...',
		'OK, thank you': 'Түсінікті, рақмет',
		'An error occurred while executing the request. Please try again later or contact a customer support service.':
			'Сұрауды орындау кезінде қате пайда болды. Әрекетті қайталаңыз немесе тұтынушыларға қолдау көрсету қызметіне хабарласыңыз.',
		'Error on confirming': 'Растау коды дұрыс емес',
		'My cabinet': 'Мәзір',
		'Orders that were booked on a previous version of the site are available':
			'Сайттың алдыңғы нұсқасында рәсімделген тапсырыстар ',
		'this link': 'сілтеме арқылы қолжетімді',
		'Operations history': 'Операциялар тарихы',
		Date: 'Күн',
		Operation: 'Операция',
		Balance: 'Теңгерім',
		'Status miles': 'Мәртебелік мильдер',
		Assessed: 'Есептелген',
		'Add booking': 'Брондауды қосу',
		'Ticket or booking number': 'Билет немесе брондау нөмірі',
		'Online check-in': 'Онлайн тіркелу',
		'Search flights': 'Рейстерді іздеу',
		'I have a booking': 'Менде брондау бар',
		'Check-in': 'Рейске тіркелу',
		'How to find a booking id?': 'Брондау идентификаторын қалай табуға болады?',
		'Check-in conditions': 'Тіркеу шарттары',
		Cancel: 'Бас тарту',
		Continue: 'Жалғастыру',
		'Last name': 'Тегі',
		'Enter the passengers surname (in latin characters) and ticket number, order ID or booking ID. You can find these in the itinerary receipt sent to purchasers Email after booking.':
			'Жолаушының тегін (латын әріптерімен) және билет нөмірін, тапсырыс нөмірін немесе брондау нөмірін енгізіңіз. Оларды брондаудан кейін сатып алушыларға электрондық пошта арқылы жіберілген маршруттық түбіртектен табуға болады.',
		'Online check-in opens 30 hours and closes 50 minutes before departure':
			'Онлайн тіркелу 30 сағат бұрын ашылады және ұшудан 50 минут бұрын жабылады.',
		'Baggage claim closes 40 minutes before flight departure. Please, check that your hand luggage weight is up to 10 kg and size does not exceed 55x40x23 cm':
			'Рейс ұшқанға дейін 40 минут бұрын жолжүкті беру жабылады. Қол жүгіңіздің салмағы 10 кг-ға дейін және өлшемі 55x40x23 см-ден аспайтынына көз жеткізіңіз.',
		'Please, make sure te passenger is not included in special category':
			'Жолаушының арнайы санатқа кірмейтініне көз жеткізіңіз.',
		'Purchase for miles': 'Мильге сатып алу',
		'Please fill in the missing fields': 'Жетіспейтін өрістерді толтырыңыз',
		'Confirm your contacts': 'Контактілеріңізді растаңыз',
		'Set your preferences': 'Қалауларыңызды белгілеңіз',
		'Add your phone number': 'Телефон нөміріңізді қосыңыз',
		'Keep building my profile': 'Профиль толтыруды жалғастыру',
		'Enter your name': 'Атыңызды толтырыңыз',
		'Welcome!': 'Қош келдіңіз!',
		'Usually traveling with a friend or family?': 'Отбасыңызбен немесе достарыңызбен жиі саяхаттайсыз ба?',
		'Add them to your companions list and make checking-in altogether easier.':
			'Деректерді енгізу процесін жеделдету үшін осы тізімге бағыты бір жолаушыларды қосыңыз',
		Passengers: 'Жолаушылар',
		'Add companion': 'Бағыты бір жолаушыны қосу',
		'Next flights': 'Ең жақын рейс',
		'My office': 'Менің кабинетім',
		Home: 'Басты',
		'Login settings': 'Кіру параметрлері',
		'Social networks accounts': 'Әлеуметтік желілер арқылы кіру',
		'Mail settings': 'Жіберілімдер',
		Profile: 'Тіркелгі',
		Edit: 'Өзгерту',
		Miles: 'Мильдер',
		Communications: 'Коммуникациялар',
		Connect: 'Қосу',
		Connected: 'Қосылды',
		'Not connected': 'Қосылмады',
		'Email will be removed from your login methods': '{{email}} поштасы кіру әдістерінен жойылады',
		'Phone will be removed from your login methods': '{{phone}} телефоны кіру әдістерінен жойылады',
		'FFP will be removed from your login methods': '{{ffp}} бейілділік картасы кіру әдістерінен жойылады',
		'Login method removal': 'Кіру әдісін жою',
		Remove: 'Жою',
		'method will be removed from your login methods': '{{method}} кіру әдістерінен жойылады',
		'Add a new login method': 'Жаңа кіру әдісін қосу',
		Add: 'Қосу',
		'A confirmation code will be sent to your address': 'Поштаңызға растау коды жіберіледі',
		'A confirmation code will be sent to your phone': 'Телефоныңызға растау коды жіберіледі',
		'Change login method': 'Кіру әдісін өзгерту',
		'Error on sending secure code': 'Растау кодын жіберу кезіндегі қате',
		'Email for notification': 'Хабарландырулар поштасы'
	},
	AddPassenger: {
		'Add passenger': 'Жолаушыны қосу',
		'Passenger last name': 'Жолаушының тегі',
		'Ticket number or booking reference': 'Билет нөмірі немесе брондау коды',
		'Ticket number': 'Билет нөмірі',
		Find: 'Іздеу',
		'Required field': 'Міндетті өріс',
		'Passenger not found': 'Жолаушы табылмады'
	},
	AdditionalBaggage: {
		'More bags?': 'Жолжүк қажет пе?',
		'Buy now and save 20-30%': 'Қазір 30%-ға дейін үнемдеңіз',
		'Check-in bags': 'Жолжүк',
		'Leave them at the check-in desk. Up to 3 bags per passenger. Price per flight.':
			'Оларды тіркеу үстелшесінде қалдырыңыз. Бір жолаушыға 3 сөмкеге дейін алуға болады. Ұшу бағасы.',
		Add: 'Қосу',
		from: 'бастап',
		Edit: 'Өзгерту',
		total: 'барлығы',
		'Check-in baggage': 'Жолжүк',
		'More baggage for you': 'Жолжүкті таңдаңыз',
		Overweight: 'Жолжүктің шегінен асып кетуі',
		'Need to add another 10-30 kg to your total checked baggage?': 'Жолжүгіңізге қосымша 10-30 кг қосыңыз'
	},
	AdditionalServiceCard: {
		Add: 'Қосу',
		Remove: 'Жою',
		Insurance: 'Сақтандыру',
		Transfer: 'Аэроэкспресс',
		'Terms of service': 'Шарттар',
		Select: 'Таңдау',
		Selected: 'Таңдалған',
		'Enter document number': 'ЖСН нөмірін енгізіңіз',
		Required: 'Өрісті толтырыңыз',
		'Only digits': '12 санды енгізіңіз',
		Done: 'Дайын',
		Clear: 'Тазалау'
	},
	AdditionalServiceWrapper: {
		'Full conditions': 'Толық шарттар',
		Cancel: 'Бас тарту',
		Ok: 'Растау',
		Clear: 'Тазалау',
		Confirm: 'Растау',
		Total: 'Барлығы'
	},
	Aeroexpress: {
		ToAirport: 'Әуежайға',
		'To airport': 'Әуежайға',
		FromAirport: 'Әуежайдан',
		'No worries about traffic jams, arrival at the airport strictly on schedule':
			'Кептелістер туралы алаңдамаңыз, әуежайға келу - қатаң кесте бойынша',
		Add: 'Қосу',
		'Fast and convenient': 'Жылдам әрі ыңғайлы',
		Transfer: 'Аэроэкспресс',
		seat_0: '{{count}} орын',
		seat_1: '{{count}} орын',
		seat_2: '{{count}} орын',
		ticket_0: '{{count}} билет',
		ticket_1: '{{count}} билет',
		ticket_2: '{{count}} билет',
		Cancel: 'Бас тарту',
		Total: 'Барлығы:',
		From: 'бастап',
		'View schedule': 'Кестені қарау',
		Terms: 'Шарттар',
		Change: 'Өзгерту',
		Done: 'Дайын',
		Clear: 'Тазалау',
		'Download tickets': 'Билеттерді жүктеп алу',
		standart: 'Стандарт',
		business: 'Бизнес',
		Download: 'Жүктеп алу',
		full: 'Cтандарт',
		roundtrip: 'Барып-қайту',
		Roundtrip: 'Барып-қайту',
		To: 'дейін'
	},
	Aircraft: {
		Embraer: 'Эмбраер',
		'E190 E2': 'E190 E2',
		Economy: 'Эконом',
		Business: 'Бизнес',
		Premium: 'Премиум',
		'Seat pitch': 'Орындық тереңдігі',
		'Up to': 'Дейін',
		'"': '"',
		'Seat width': 'Орындықтар ені',
		'Seat recline': 'Орындықтың арқасы еңкейтіледі',
		'The Embraer E-Jet E2 family are medium-range jet airliners developed by Embraer, succeeding the original E-Jet. The program was launched at the Paris Air Show in 2013. The first variant, the E190-E2, took its first flight on 23 May 2016 and was certified on February 28, 2018 before entering service with Widerøe on 24 April. The three twinjet variants share the same four-abreast narrow-body fuselage with different lengths and three different new wings, Pratt & Whitney PW1000G turbofans in two sizes, fly-by-wire controls with new avionics, and an updated cabin.':
			'Embraer E-Jet E2 тобы - бұл түпнұсқалық E-Jet-ті алмастырған Embraer әзірлеген орташа қашықтыққа арналған реактивті авиалайнерлер. Бағдарлама 2013 жылы Париждегі авиасалонда іске қосылды. E190-E2 ұшағының бірінші нұсқасы өзінің алғашқы рейсін 2016 жылдың 23 мамырында жасап, 2018 жылдың 28 ақпанында сертификатталды, ал 24 сәуірде Widerøe қатарына қосылды. Twinjet үш нұсқасында ұзындығы әртүрлі және үш жаңа қанаты бар бірдей төрт контурлы тар шанақ, Pratt & Whitney PW1000G турбореактивті желдеткіштері екі өлшемді, жаңа авионикамен ұшу барысында басқару элементтері және жаңартылған кабина бар.',
		Max: 'Макс',
		nmi: 'тм',
		ft: 'фт.',
		cm: 'см',
		'National origin': 'Өндіріс',
		Brasil: 'Бразилия',
		Manufacturer: 'Өндіруші',
		Status: 'Күй',
		'In service': 'Қызмет көрсетіледі',
		Produced: 'Өндірілген',
		'Flight deck crew': 'Команда',
		'2 pilots': '2 ұшқыш',
		'Seating, dual class': 'Отыратын орын, қос класс',
		'96 12j @38in': '96 12j @38in',
		'18.3 in (46 cm)': '18,3 дюйм (46 см)',
		Length: 'Ұзындығы',
		'36.24 m': '36,24 м.',
		Wingspan: 'Қанат құлашы',
		'33.72 m': '33,72 м.',
		Speed: 'Жылдамдығы',
		'Mach 0.82 (473 kn; 876 km/h) Max': 'Мах 0,82 (473; 876 км/сағ) Макс.',
		'Range (full pax)': 'Ұшу алыстығы',
		'3,250 nmi (6,020 km)': '3,250 тм (6,020 км)',
		'Service ceiling': 'Максималды биіктік',
		'41,000 ft (12,000 m)': '41,000 фт. (12,000 м)',
		Engines: 'Қозғалтқыштар',
		'2× Pratt & Whitney PW1919G/21G/22G/23G': '2× Pratt & Whitney PW1919G/21G/22G/23G',
		Title_PassengerCapacity: 'Сыйымдылығы',
		Title_CruisingSpeed: 'Жылдамдығы',
		Title_MaxFlightRange: 'Қашықтығы',
		Unit_PassengerCapacity: 'орын',
		Unit_CruisingSpeed: 'км/сағ',
		Unit_MaxFlightRange: 'км'
	},
	Airport: {
		'Open web site': 'Сайтты ашу',
		Departures: 'Ұшып шығу',
		Arrivals: 'Ұшып келу',
		Summary: 'Ақпарат',
		Services: 'Қызметтер',
		Map: 'Карта'
	},
	BaggagePage: {
		Baggage: 'Жолжүк',
		'Transportation of impressions no limitations': 'Тәжірибелерді сынап көру\nшексіз',
		'Baggage rules': 'Жолжүкті алып жүру ережелері',
		Adult: 'Ересек',
		Child: 'Бала',
		Infant: 'Нәресте'
	},
	BaggageService: {
		'Set the same baggage for each flight': 'Барлық бағыттарға жолжүк орындарының бірдей саны',
		'Set the different baggage for each flight': 'Барлық бағыттарға жолжүк орындарының әртүрлі саны ',
		'If the dimensions of your carry-on baggage exceed the permitted dimensions of 40x30x20 cm, you can increase its size up to 55x40x20 cm':
			'Қол жүгіңіздің габариттері рұқсат етілген 40x30x20 см өлшемдерінен асса, оның өлшемін 55x40x20 см-ге дейін ұлғайтуға болады',
		'Sports equipment': 'Спорт жабдығы',
		'Add sports equipment': 'Спорт жабдығын қосу',
		'Your can bring your ski, snowboard, surf equipment, bicycle, etc. packed in a pouch':
			'Шаңғыны, сноубордты, велосипедті арнайы қаптарына салып өзіңізбен бірге алуыңызға болады',
		included: 'қамтылған',
		Add: 'Қосу',
		Selected: 'Таңдалған',
		kg: 'кг',
		'pcs.': 'д.',
		Overweight: 'Жолжүк салмағының артуы',
		'Improve baggage weight you can bring to airplane':
			'Егер жолжүгіңіздің салмағы рұқсат етілген нормадан асып кетсе, оның салмағын ұлғайтуыңызға болады',
		'{{value}} kg': '{{value}} кг',
		'Checked-in baggage': 'Тіркелген жолжүк',
		'up to {{value}} kg': '{{value}} кг-ға дейін',
		'Increasing the size of carry-on baggage': 'Қол жүгінің габариттерін ұлғайту',
		'You can bring your ski, snowboard, surf equipment, bicycle, golf bag, etc.':
			'Өзіңізбен бірге шаңғыны, сноубордты, серфинг жабдықтарын, велосипедті, гольф сөмкесін және т.б. алуыңызға болады',
		Done: 'Дайын',
		Clear: 'Тазалау',
		RUB: '₽',
		USD: '$',
		from: 'бастап',
		'The service is applied to directions': 'Қызмет бағыттарға қолданылады',
		'The service is applied to all directions': 'Қызмет барлық бағыттарға қолданылады',
		CarryOn: 'Қол жүк',
		Baggage: 'Жолжүк',
		SportingEquipment: 'Арнайы жабдық'
	},
	BaggageTotalPriceBlock: {
		Add: 'Қосу',
		edit: 'Өзгерту',
		from: 'бастап',
		'More bags': 'Жолжүк'
	},
	Cart: {
		Flights: 'Ұшулар',
		Baggage: 'Жолжүк',
		Seats: 'Орындар',
		Meal: 'Тамақтану',
		Passengers: 'Жолаушылар',
		Contacts: 'Контактілер',
		'All flights': 'Барлық рейстер',
		Total: 'Барлығы: ',
		Close: 'Жабу',
		ADT: 'Ересек',
		CLD: 'Бала',
		INF: 'Нәресте',
		INS: 'Орны бар нәресте',
		Extra: 'Қосымша',
		Aeroexpress: 'Аэроэкспресс',
		Insurances: 'Сақтандыру',
		'Business lounge': 'Бизнес зал',
		'The service you have added cannot be activated. Try connecting later or contact the airline operator.':
			'Сіз қосқан қызметті белсендіру мүмкін емес. Кейінірек қосылып көріңіз немесе әуе компаниясының операторына хабарласыңыз.',
		'The service is awaiting confirmation. Do not close or refresh the window.':
			'Қызмет растауды күтуде. Терезені жаппаңыз немесе жаңартпаңыз.'
	},
	Checkin: {
		'Oops, something went wrong': 'Ой, бірдеңе дұрыс болмады',
		'But don\'t worry, all of our systems have been duplicated several times. You can register on the backup version of the site.':
			'Бірақ алаңдамаңыз, біздің барлық жүйелеріміз бірнеше рет қайталанған. Сайттың резервтік нұсқасында тіркелуіңізге болады.',
		Go: 'Резервтік сайтқа өту',
		'Try again': 'Қайталап көру',
		From: 'Бастап',
		'Please, enter your contacts': 'Байланыс деректеріңізді енгізіңіз',
		'Ticket number or booking reference': 'Билет нөмірі немесе брондау коды',
		'Inflight insurance or baggage insurance is your travel confidence.':
			'Ұшу уақытын сақтандыру немесе жолжүкті сақтандыру - сіздің саяхатқа деген сеніміңіз.',
		'Checkin canceled, you will be redirected to the beginning':
			'Тіркеу тоқтатылды, сіз бастамасына қайта бағытталасыз',
		'Passenger last name': 'Жолаушының тегі',
		'Oops...': 'Ой...',
		Continue: 'Жалғастыру',
		'OK, thank you': 'Түсінікті, рақмет',
		'An unexpected error has occurred during the start of the check-in process. Please try again later or contact a customer support service.':
			'Онлайн тіркелуді бастау әрекеті кезінде қате пайда болды. Әрекетті қайталаңыз немесе тұтынушыларға қолдау көрсету қызметіне хабарласыңыз.',
		'Online check-in': 'Онлайн тіркелу',
		Passengers: 'Жолаушылар',
		Next: 'Келесі',
		'Find booking': 'Тапсырысты іздеу',
		Baggage: 'Жолжүк',
		Seats: 'Орын таңдау',
		Meal: 'Тамақтану',
		Payment: 'Төлем',
		'Boarding pass': 'Отырғызу талоны',
		'Choose passengers for check-in': 'Тіркелетін жолаушыларды таңдаңыз',
		'How to find a booking?': 'Тапсырысты қалай табуға болады?',
		'Enter the passenger last name (in latin characters) and the booking code. \nYou can find it in the itinerary receipt sent to your email after booking.':
			'Пішінде билет нөмірін немесе брондау кодын және жолаушының тегін енгізіңіз. Осыдан кейін «Іздеу» түймесін басыңыз.',
		'Incorrect last name or booking code': 'Тегі немесе брондау коды дұрыс емес',
		'Check-in Successful': 'Тіркелу аяқталды',
		'Sorry,': 'Өкінішке орай,',
		'online check-in is closed for this flight': 'бұл рейске онлайн тіркелу жабық',
		OK: 'OK',
		'You can now download and print your boarding passes. You will need them at the airport.':
			'Отырғызу талондарын басып шығаруды ұмытпаңыз. Олар ұшу алдындағы тексеру кезінде, төлқұжаттық бақылауда, қонуға шығу кезінде және әуе кемесінің бортында қажет.',
		'An error occurred during the check-in process. Please try again later or contact a customer support service.':
			'Онлайн тіркелу кезінде қате пайда болды. Әрекетті қайталаңыз немесе тұтынушыларға қолдау көрсету қызметіне хабарласыңыз.',
		'Anything else for your trip?': 'Тағы бір нәрсе бар ма?',
		Extras: 'Қосымша қызметтер',
		'Online check-in will close at': 'Онлайн тіркелу ... аяқталады',
		'To complete online check-in you must choose seats for all passengers on all flight directions':
			'Рейске онлайн тіркелу үшін барлық жолаушыларға және барлық бағыттарға арналған ұшақ салонындағы орындарды таңдау қажет',
		'Unfortunately, check-in cancellation is prohibited for this flight. Please contact a customer support service for further details.':
			'Өкінішке орай, осы рейсте онлайн тіркелуден бас тартуға тыйым салынған. Толығырақ ақпарат алу үшін тұтынушыларға қолдау көрсету қызметіне хабарласыңыз.',
		'Please, enter your visa details': 'Виза туралы деректерді толтырыңыз',
		Save: 'Сақтау',
		Download: 'Жүктеп алу',
		'Go to home': 'Басты бетке өту',
		'Business lounge': 'Бизнес зал',
		from: 'бастап',
		Change: 'Өзгерту',
		'No visa required': 'Өткізіп жіберу',
		'Start online check-in': 'Онлайн тіркелу',
		'Last name': 'Тегі',
		'Ticket / booking number': 'Билет/бронь нөмірі',
		'Booking not found':
			'Брондау табылмады. Енгізілген ақпаратты тексеріңіз немесе сәйкестендіру үшін электрондық билет нөмірін пайдаланыңыз',
		Required: 'Міндетті өріс',
		'Incorrect value': 'Қате мән',
		'How to find a booking id?': 'Бронь нөмірін қалай табуға болады?',
		HelpBookingFind:
			'Жолаушының тегін (латын әріптерімен) және билет нөмірін, тапсырыс нөмірін немесе брондау нөмірін енгізіңіз. \nОларды брондаудан кейін сатып алушыларға электрондық пошта арқылы жіберілген маршруттық түбіртектен табуға болады.',
		Conditions: 'Шарттар',
		Add: 'Қосу',
		Cancel: 'Бас тарту',
		'airport local time': 'әуежайдың жергілікті уақыты бойынша',
		'Seats have already been assigned by the airline and check-in is only available at the counter at the airport':
			'Орындар әуе компаниясымен тағайындалған және тіркеу тек әуежай үстелшесінде қолжетімді',
		Attention: 'Назар аударыңыз',
		Close: 'Жабу',
		'Invalid seat number':
			'{{seatNumber}} орнымен онлайн тіркелу мүмкін емес, сізге әуежай үстелшесінде тіркелу қажет.',
		'You can now download and print your boarding passes. You will need them at the airport.\n Please notice, for flight {{flight}} you must receive your boarding pass at the airport':
			'Отырғызу талондарын басып шығаруды ұмытпаңыз. Олар ұшу алдындағы тексеру кезінде, төлқұжаттық бақылауда, қонуға шығу кезінде және әуе кемесінің бортында қажет.\nНазар аударыңыз, {{flight}} рейсіне тек әуежайдан қонуға болады.',
		'You can now download and print your boarding passes. You will need them at the airport.\n Please notice, for flight {{flight}} you must receive your boarding pass at the airport_1':
			'Отырғызу талондарын басып шығаруды ұмытпаңыз. Олар ұшу алдындағы тексеру кезінде, төлқұжаттық бақылауда, қонуға шығу кезінде және әуе кемесінің бортында қажет.\nНазар аударыңыз, {{flight}} рейсіне тек әуежайдан қонуға болады.',
		'Service is temporarily unavailable. There are no seats available. Please try again later, or check in at the airport.':
			'Қызмет уақытша қолжетімді емес. Қолжетімді орындар жоқ. Әрекетті кейінірек қайталаңыз немесе әуежайда тіркелуіңізді сұраймыз.',
		'Checkin available only in airport': 'Онлайн тіркелу қолжетімді емес. Тек әуежайда тіркелуге болады',
		'You cannot add a passenger because the currency of order is different from the currency of orders of previously added passengers.\nYou can check-in the passenger separately.':
			'Жолаушыны қосу мүмкін емес, себебі оның тапсырыс валютасы бұрын қосылған жолаушылардың тапсырыстар валютасынан ерекшеленеді.\nОны рейске бөлек тіркеуге болады.'
	},
	CheckinAddDocuments: {
		Submit: 'Сақтау',
		'Add documents': 'Құжаттарды қосу'
	},
	CheckinConditions: {
		'Check-in conditions': 'Тіркеу шарттары',
		OpenCloseCheckinCondition:
			'Онлайн тіркелу ұшудан 30 сағат бұрын ашылады және кетуге 50 минут қалғанда жабылады',
		BaggageCondition:
			'Жолжүкті беру рейс ұшқанға дейін 40 минут бұрын жабылады. Қол жүгіңіздің салмағы 10 кг-нан аспайтынына және өлшемі 55x40x23 см-ден аспайтынына көз жеткізіңіз',
		PassengersCondition: 'Жолаушының арнайы санатқа кірмейтініне көз жеткізіңіз'
	},
	CheckinRules: {
		Continue: 'Жалғастыру',
		'Terms & Conditions': 'Онлайн тіркелу шарттары мен ережелері',
		'I have read and agreed to the online check-in terms and conditions':
			'Мен онлайн тіркелу шарттарымен және ережелерімен танысып, келісім бердім',
		'Please read and accept the online check-in terms and conditions':
			'Онлайн тіркелу шарттарымен және ережелерімен танысып, келісуіңізді сұраймыз'
	},
	Checkout: {
		'Review your trip': 'Сіздің тапсырысыңыз',
		'LOUNGE ACCESS': 'Бизнес зал',
		'PRE RESERVED SEAT ASSIGNMENT': 'Орын таңдау',
		Details: 'Толық мәліметтер',
		'Miles will be credited to your account after the flight.':
			'Мильдер сіздің дербес шотыңызға ұшу аяқталғаннан кейін түседі.',
		'Start earning miles now to flight cheaper': 'Арзанырақ бағаға ұшу үшін миль алуды бастаңыз',
		Register: 'Тіркеу',
		'View status': 'Күйді қарау',
		'{{number}} {{miles}} will be awarded': '{{number}} {{miles}} есептеледі',
		miles: 'миль',
		miles_0: 'миль',
		miles_1: 'миль',
		miles_2: 'миль',
		'Light Jet Club': 'Websky Club',
		'Get our latest offers': 'Арнайы сізге арналған',
		Cancel: 'Бас тарту',
		'Sign up for NORDWIND newsletter and enjoy invites to major sales and exclusive offers and always be in the know.':
			'Nordwind әуе компаниясының жаңалықтарына жазылып, барлық өзекті сатылымдарға, керемет ұсыныстарға шақырулар алыңыз және біздің жоспарларымыздан үнемі хабардар болыңыз.',
		'I accept the': 'Мен',
		'terms of agreement': 'шарт талаптарымен келісемін',
		'terms of insurances': 'сақтандыру талаптарымен келісемін',
		'Sorry, the price has changed to': 'Өкінішке орай, баға ... дейін өзгерді',
		'Wow, the price has changed to': 'Мәссаған, баға ... дейін төмендеді',
		'We recommend buying your tickets now to avoid another price increase.':
			'Бағалар кез келген уақытта көтерілуі мүмкін, сатып алуды кейінге қалдырмаңыз!',
		'Sorry, flight is either not available or sold out': 'Өкінішке орай, бұл рейске орындар аяқталды',
		'Please, choose another flight.': 'Басқа рейсті таңдаңыз.',
		'Choose another flight': 'Басқа ұшуды таңдау',
		'old price': 'бұрынғы баға',
		'Change flight': 'Рейсті ауыстыру',
		Continue: 'Жалғастыру',
		Required: 'Толтыру қажет',
		'Please, read the rules of service and accept it':
			'Жалғастыру үшін қызмет көрсету ережелерімен танысып, келісіңіз',
		Seats: 'Орындар',
		Baggage: 'Жолжүк',
		Meal: 'Тамақтану',
		'Select seats': 'Орындарды таңдау',
		'Select meal': 'Тамақтану түрін таңдау',
		'Checked-in baggage': 'Қосымша жолжүк',
		Adult: 'Ересек',
		Child: 'Бала',
		Infant: 'Нәресте',
		Status: 'Тапсырыс күйі',
		'Payment details': 'Құнын нақтылау',
		Service: 'Қызмет',
		'processing of my personal data': 'жеке деректерді өңдеу шарттарымен',
		'general transportation rules': 'тасымалдаудың жалпы ережелерімен',
		'and I accept it. I am aware that the fee for unused additional services is not refundable.':
			'және оларды қабылдаймын. Пайдаланылмаған қосымша қызметтер үшін ақы қайтарылмайтынын білемін.',
		and: 'және',
		Price: 'Бағасы',
		Total: 'Барлығы',
		Booked: 'Брондалған',
		Cancelled: 'Бас тартылды',
		Confirmed: 'Рәсімделген',
		New: 'Жаңа',
		'Thank you for your booking!': 'Билеттер сәтті рәсімделді!',
		Back: 'Артқа',
		'Priority boarding': 'Басымдықты отырғызу',
		Insurance: 'Сақтандыру',
		Transfer: 'Трансфер',
		Aeroexpress: 'Аэроэкспресс',
		Flight: 'Ұшу',
		Flights: 'Ұшулар',
		'Selected options': 'Таңдалған ұшулар',
		Clarification: 'Назар аударыңыз',
		'Skip the line at the gate and board the aircraft early.': 'Бірінші кезекте және кезексіз отырғызу.',
		'Guaranteed overhead baggage space.': 'Кепілдендірілген жолжүк орны.',
		'More time to get comfortable on board.': 'Басқа жолаушылардан бұрын отырғызу.',
		'Coverage for medical expenses, also suitable for visa. Business lounge in case of delay. Get 30 miles':
			'Медициналық жағдайларды, сондай-ақ визамен байланысты жағдайларды жабады. Қосымша 30 миль алыңыз',
		'No worries about traffic jams, arrival at the airport strictly on schedule.':
			'Кептеліс туралы алаңдамаңыз. Отырғызғаннан кейін бірден қала орталығына ауысыңыз.',
		'Be among the first to board': 'Алғашқы жолаушылар қатарында',
		'Basic Packet': 'Негізгі пакет',
		'Fast and convenient': 'Жылдам әрі ыңғайлы',
		'Are you sure you are ready to remove insurance?': 'Сақтандырудан бас тартуға дайын екеніңізге сенімдісіз бе?',
		'Inflight insurance or baggage insurance is your travel confidence.':
			'Ұшу уақытын сақтандыру немесе жолжүкті сақтандыру - сіздің саяхатқа деген сеніміңіз.',
		'Flying with risk': 'Барлық тәуекелдерді өзіме аламын',
		Insure: 'Сақтандыруды қалдыру',
		Add: 'Қосу',
		'Download policy': 'Полисті жүктеп алу',
		'Show details': 'Толық мәліметтерді қарап шығу',
		'Hide details': 'Толық мәліметтерді жасыру',
		'Go to online check-in': 'Онлайн тіркелу',
		'Change / Refund': 'Ауыстыру / Қайтару',
		'Tickets have been sent to {{email}}': 'Билеттер {{email}} мекенжайына жіберілді',
		'Resend it': 'Қайта жіберу',
		'Enjoy the extended range of dishes and top-notch services on board, earn extra miles':
			'Тағамдардың кеңейтілген сұрыптамасынан және борттағы бірінші дәрежелі қызметтерден ләззат алып, қосымша мильдер табыңыз',
		Passengers: 'Жолаушылар',
		'Oops...': 'Ой...',
		'OK, thank you': 'Түсінікті, рақмет',
		'An unexpected error has occurred during the booking process. Please try again later or contact a customer support service.':
			'Орындарды брондау кезінде қате пайда болды. Әрекетті қайталаңыз немесе тұтынушыларға қолдау көрсету қызметіне хабарласыңыз.',
		'An unexpected error has occurred during the tickets downloading process. Please try again later or contact a customer support service.':
			'Билеттерді жүктеп алу кезінде қате пайда болды. Әрекетті қайталаңыз немесе тұтынушыларға қолдау көрсету қызметіне хабарласыңыз.',
		Send: 'Жіберу',
		Email: 'Эл. поштаның мекенжайы',
		'Resend booking': 'Билеттерді жіберу',
		'Failed to send tickets to the specified mail, try again later':
			'Көрсетілген поштаға билеттерді жіберу мүмкін болмады, әрекетті қайталаңыз',
		'Please enter a valid email': 'Енгізілген эл. пошта мекенжайын тексеріңіз',
		'Select seat': 'Орын таңдау',
		'If you will not select a seat now, we will automatically select it for you upon check-in.':
			'Орынды қазір таңдауды ұсынамыз, үздік орындарды бірінші болып үлгергендер алады!',
		'Next step': 'Қызметтерді рәсімдеуге өту',
		'Now you will be redirected to the previous version of the site. There you can choose ancillary services.':
			'Қазір біз сізді сайттың алдыңғы нұсқасына бағыттаймыз. Уақытша, дәл сол жерде сіз қажетті қосымша қызметтерді рәсімдеп, ұшуды ұмытылмастай ете аласыз.',
		'Add now': 'Қызметтерді таңдау',
		'Order has been cancelled': 'Тапсырыстың күші жойылды',
		'Your special comfort on board': 'Борттағы жайлылық',
		'Improve your flight right now by adding the pleasant and necessary comfort with special food, extra baggage and the best places with amazing views.':
			'Ұшуды ерекше етіңіз. Тапсырысыңызға таңдаулы тағамдарды, қосымша жолжүк пен қол жүгін қосыңыз немесе иллюминатордың әсерлі көрінісін тамашалаңыз.',
		Resend: 'Қайта жіберу',
		'Thank you for your choice. All need documents has been sent to your e-mail address.':
			'Таңдағаныңыз үшін рақмет. Барлық қажетті құжаттар сіздің электрондық поштаңызға жіберілді.',
		'Paid by credit card': 'Картамен төленген',
		'Waiting for payment expires at': 'Төлемді күту ... аяқталады',
		Ref: 'Тапсырыс нөмірі',
		'Security code': 'Кіру коды',
		Download: 'Жүктеп алу',
		'Price details': 'Барлығы',
		'Baggage rules': 'Жолжүкті алып жүру ережелері',
		'Feel the taste in flight!': 'Ұшудан ләззат алыңыз!',
		'Transportation of impressions no limitations': 'Тәжірибелерді сынап көру шексіз',
		'The top ones get the top seats!': 'Үздік орындарды бірінші болып үлгергендер алады!',
		'Fly in comfort': 'Жайлылық күй-жайында ұшыңыз',
		from: 'бастап',
		Change: 'Өзгерту',
		Refund: 'Қайтару',
		Exchange: 'Айырбастау',
		'Seat selection is available in the online registration service':
			'Орындарды таңдау онлайн тіркелу қызметінде қолжетімді',
		'You can select seats using the online registration service after issuing tickets':
			'Билетті рәсімдегеннен кейін онлайн тіркелу қызметін пайдалана отырып, орын таңдауға өте аласыз',
		'Business lounge': 'Бизнес зал',
		'The flight is available, hurry up with booking!': 'Орындар әлі бар, брондауға асығыңыз!',
		'Attention, times have changed for flight {{route}}': 'Назар аударыңыз! {{route}} рейсінің күйі өзгерді',
		'More details': 'Толығырақ',
		'Capsule hotel': 'Капсулалық қонақ үй',
		'per person': 'бір адамға',
		'Full conditions': 'Толық шарттар',
		'Total for all passengers': 'Барлық жолаушылардың жалпы саны',
		Aeroexpress_Cancel: 'Бас тарту',
		Ok: 'Ок',
		Class_full: 'Стандарт',
		Class_business: 'Бизнес',
		Class_child: 'Балалық',
		Class_family: 'Отбасылық',
		Class_couple: 'Жұптық',
		Class_standart: 'Стандарт',
		Class_roundtrip: 'Стандарт',
		Class_business_roundtrip: 'Бизнес',
		ToAirport: 'Бір жаққа',
		FromAirport: 'Бір жаққа',
		Roundtrip: 'Барып-қайту',
		'And back': 'Және қайту',
		'Aeroexpress tickets are valid for 30 days.': 'Аэроэкспресс билеттері 30 күнге жарамды.',
		'passenger conduct rules': 'жолаушылардың мінез-құлық ережелері',
		'terms of tariff': 'тариф шарттарымен',
		'Search my booking': 'Тапсырысты іздеу',
		Done: 'Дайын',
		'Passenger not found. Please, check passenger last name and ticket number':
			'Жолаушы табылмады, енгізілген деректерді тексеріңіз',
		'Add passenger': 'Жолаушыны қосу',
		'Add your travel companion to the order? Add ticket': 'Осы тапсырыстың жолаушысын қосыңыз',
		'price for all persons': 'барлық адамдарға арналған баға',
		Select: 'Таңдау',
		Reject: 'Қабылдамау',
		'SMS notifications': 'SMS хабарландырулары',
		Clear: 'Тазалау',
		'Open the full text of the conditions of carriage': 'Тасымалдау шарттарының толық мәтінін ашу',
		Animal: 'Үй жануарлары',
		'All payments will be charged in Russian rubles. The amounts indicated in other currencies are presented as a guideline.':
			'Барлық төлемдер ресей рублімен есептен шығарылады. Басқа валюталарда көрсетілген сомалар анықтамалық ақпарат ретінде ұсынылады.',
		'Only 1 animal is allowed per adult passenger.': '1 ересек жолаушыға тек 1 жануар рұқсат етіледі.',
		'Placement of passengers with an animal in the front rows is prohibited.':
			'Жануарлары бар жолаушыларды бірінші қатарға орналастыруға тыйым салынады.',
		'Specify all passengers for whom you need to open an order for correct display.':
			'Дұрыс көрсету үшін тапсырысын ашу қажет барлық жолаушыларды енгізіңіз.',
		'View old booking': 'Байланысты тапсырысты ашу',
		'Order created from': '... тапсырыс жасалған',
		'You must select seats to proceed to the next step': 'Келесі қадамға өту үшін орындарды таңдаңыз',
		'All flight': 'Барлық рейстер',
		'Promo code': 'Промокод',
		Passenger: 'Жолаушы',
		'Original price': 'Бастапқы баға',
		'Final price': 'Жеңілдік бағасы',
		'Total price': 'Қорытынды баға',
		'Correct promo codes': 'Промокодтарды түзету',
		'Check if the promo code is entered correctly or contact the call center of the airline':
			'Қолжетімді жеңілдіктер жоқ. Промокодты дұрыс енгізгеніңізді тексеріңіз немесе әуе компаниясының байланыс орталығына хабарласыңыз.',
		'Add services': 'қосымша қызметтер',
		Error: 'Қате',
		'An error occurred while checking the promo code, change the promo code or continue without it':
			'Промокодты тексеру кезінде қате пайда болды, промокодты өзгертіңіз немесе онсыз жалғастырыңыз.',
		'Promo codes not available': 'Промокодтар қолжетімді емес',
		'We recommend using extra baggage': 'Қосымша "{{name}}" жолжүгін пайдалануды ұсынамыз',
		'Extra delivery baggage': 'Жаңа "{{name}}" қызметін пайдалануды ұсынамыз,\n жеңіл саяхаттаңыз!',
		'Extra delivery baggage free for dates': 'Қызмет 18.04.24 және 20.04.24 аралығындағы ұшуларға тегін',
		Refuse: 'Бас тарту',
		Agree: 'Қызмет қосу',
		Remove: 'Жою',
		'Prices are for all passengers, including taxes and fees. By local time.':
			'Бағалар барлық жолаушыларға, соның ішінде салықтар мен алымдарға арналған. Жергілікті уақыт.',
		'Error from supplier. Passenger\'s name and/or surname is too long':
			'Жолаушының аты және/немесе тегі рұқсат етілген таңбалар санынан асады',
		Confirm: 'Растау',
		'Extra comfort': 'Қосымша жайлылық',
		'VIP lounges, business lounges, priority pre-flight procedures':
			'VIP залдар, бизнес залдар, ұшу алдындағы процедуралар жеделдетіп өту',
		'To book': 'Брондау',
		'Your order was archived. Please contact with client support to get a receipt':
			'Тапсырыс мұрағатқа көшірілді. Маршруттық түбіртекті алу үшін қолдау орталығына хабарласыңыз.',
		pet_popup_rules: '[List]',
		'Miles are not credited for this flight.': 'Бұл ұшуға мильдер есептелмейді.',
		'Baggage delivery': 'Жолжүкті жеткізу',
		'per place': 'бір жолжүк орны үшін',
		'All passengers': 'Барлық жолаушылар',
		'Proceeding to payment...': 'Өтінемін, күте тұрыңыз',
		'An order for this flight and the set of passengers already exists':
			'Мұндай жолаушылар жиынымен осы рейске тапсырыс бұрыннан бар',
		'У разных элементов Traveller не может быть одинакового значение параметра LinkedTo, большего чем 0':
			'Бір ересек адам жеке орындары жоқ екі немесе одан да көп нәрестелерді алып жүруші ретінде көрсетілмейді. Әр нәресте үшін басқа ересек адамдарды енгізіңіз.',
		'You are not logged in': 'Жүйеге кірген жоқсыз',
		'Add protection': 'Қорғанысты қосу',
		'Remove protection': 'Қорғанысты жою',
		'For all passengers': 'Барлық жолаушылар үшін',
		'Want to add extra protection while traveling?': 'Саяхат кезінде қосымша қорғаныс қосқыңыз келе ме?',
		InsuranceGroupTitle_default: 'Сақтандыру',
		InsuranceGroupDescr_default: 'Ұшып шығуды кешіктірген немесе тоқтатқан жағдайда шығындарды өтеу',
		InsuranceGroupTitle_common: 'Ұшуды өзгерту бойынша сақтандыру',
		InsuranceGroupDescr_common:
			'Сапар күні жойылған немесе өзгертілген жағдайда <strong> 40 000 RUB дейін </strong> өтемақы алыңыз.',
		InsuranceGroupTitle_flight: 'Ұшу уақытына кешенді сақтандыру',
		InsuranceGroupDescr_flight:
			'Ұшуды кешіктірген немесе тоқтатқан жағдайда 500 000 рубльге дейін өтемақы, ұшу уақытында жолжүк пен денсаулықты қорғау қамтамасыз етіледі.',
		InsuranceGroupTitle_med: 'Медициналық сақтандыру',
		InsuranceGroupDescr_med:
			'Шетелге шығу үшін міндетті түрде қажет. Амбулаториялық немесе стационарлық емдеуді, оның ішінде COVID-19 кезінде стоматологияны, медициналық тасымалдауды, балаларды эвакуациялауды, құжаттарды қалпына келтіруді қамтиды.'
	},
	CheckoutAdditionalService: {
		Add: 'Қосу',
		from: 'бастап',
		Exclusive: 'Эксклюзивті'
	},
	CheckoutOrderSummary: {
		'Order must be paid': 'Тапсырысты төлеу қажет',
		before: 'дейін',
		'today before': 'бүгін ... дейін',
		'View details': 'Ұшу туралы толық мәліметтер',
		'Order number': 'Тапсырыс нөмірі'
	},
	Communications: {
		Communications: 'Коммуникациялар',
		Notifications: 'Хабарландырулар',
		'My appeals': 'Менің өтініштерім',
		Chat: 'Чат',
		Promotions: 'Хабарландырулар',
		'Order notifications': 'Тапсырыстар бойынша хабарландырулар',
		'My promo codes': 'Менің промокодтарым',
		Back: 'Артқа',
		'Mark all as read': 'Барлығын оқылған деп белгілеу',
		Updated: 'Жаңартылған',
		Created: 'Жасалған',
		Status: 'Күй',
		'Call to action': 'Әрекетке шақыру',
		Order: 'Тапсырыс',
		'Book with promo code': 'Промо-кодпен брондаңыз',
		Personal: 'Жеке',
		Reusable: 'Көп реттік',
		New: 'Жаңа',
		WaitingAnswer: 'Жауап күтуде',
		InProgress: 'Орындалуда',
		Solved: 'Орындалды',
		Rejected: 'Қабылданбады',
		Used: 'Пайдаланылған',
		Expired: 'Мерзімі аяқталды',
		'Can be used until': '...дейін пайдалануға болады',
		ID: 'ID',
		Oops: 'Ой...',
		'Something went wrong': 'Бірдеңе дұрыс болмады',
		'Mark as read': 'Оқылған деп белгілеу',
		'There is nothing yet': 'Әлі ештеңе жоқ',
		Empty_my_appeals: 'Сізде әлі өтініштер жоқ',
		Empty_promotions: 'Сізде әлі маркетингтік хабарландырулар жоқ',
		Empty_order_notifications: 'Сізде әлі тапсырыстар жоқ',
		Empty_my_promo_codes: 'Сізде әлі промокодтар жоқ'
	},
	CompareFares: {
		Label: 'Түйме',
		'Internal error': 'Ішкі қате',
		'Compare fare families': 'Тарифтер тобын салыстыру',
		Economy: 'Эконом',
		Light: 'Лайт',
		Classic: 'Классик',
		Flex: 'Икемді',
		Business: 'Бизнес',
		Premium: 'Премиум',
		Baggage: 'Жолжүк',
		'Checked baggage': 'Тіркелетін жолжүк',
		Services: 'Қызметтер',
		'Ticket changes': 'Билеттегі өзгерістер',
		Cancellation: 'Бас тарту',
		'In-Cabin service': 'Борттағы қызметтер',
		'Comfort kit': 'Жайлылық жинағы',
		'Airport sevices': 'Әуежайдағы қызметтер',
		'Priority boarding': 'Басымдықты отырғызу',
		'Priority baggage delivery': 'Жолжүкті бірінші кезекте жеткізу',
		'Lounge service': 'Демалыс бөлмесі',
		'View full fare conditions': 'Тарифтерді толығымен салыстыру',
		Note: 'Ескертпе',
		'Go back': 'Қайту',
		'The fare difference is calculated taking into account the prices available through our global reservations system, not the airBaltic website':
			'Тарифтердегі айырмашылық airBaltic сайтында емес, біздің жаһандық брондау жүйесі арқылы қолжетімді бағаларды ескере отырып есептеледі',
		'Please see detailed baggage rules that apply to airBaltic operated flights here':
			'airBaltic әуе компаниясымен орындалатын рейстерде қолданылатын жолжүкті тасымалдаудың толығырақ ережелерімен мұнда танысыңыз.',
		'Passengers in possession of roundtrip tickets who have flown or are planning to fly one way only and wish to receive a refund for the unused part of the ticket, please make sure that the ticket type supports cancellation with refund. In such cases the value of the used portion of the ticket will be recalculated to reflect the price of a one-way ticket, and the remaining difference will be refunded after subtracting any cancellation fees, if applicable to the particular ticket type.':
			'Ұшып келген немесе тек бір бағытқа ұшуды жоспарлаған және билеттің пайдаланылмаған бөлігі үшін өтемақы алғысы келетін жолаушылар билет түрі кері қайтаруды қолдайтынына көз жеткізіңіз. Мұндай жағдайларда билеттің пайдаланылған бөлігінің құны бір жақты билеттің бағасын көрсету үшін қайта есептеледі, ал қалған айырма билеттің нақты түріне қолданылатын болса, күшiн жойғаны үшін кез келген алым шегерiлгеннен кейiн қайтарылады.',
		'Name and/or surname change or correction is only possible if the ticket issued is an airBaltic document and the booking consists of flights operated by airBaltic.':
			'Берілген билет airBaltic құжаты болып табылатын және брондау airBaltic орындайтын рейстерден тұратын жағдайда ғана атын және/немесе тегін өзгерту немесе түзету мүмкін болады.',
		'Applicable for tickets booked after 18th of February 2018, for tickets booked before 19th of February, cancellation allowed anytime. A refund fee of 100 EUR applies to each ticket.':
			'2018 жылдың 18 ақпанынан кейін брондалған билеттерге, 19 ақпанға дейін брондалған билеттерге кез келген уақытта бас тартуға рұқсат етіледі. 100 еуро мөлшеріндегі төлемді қайтару әр билетке қолданылады',
		'For tickets that are purchased until 31.05.2018, a transition period from 01.06.2018-30.06.2018 is applicable. During this period fee is EUR 50.':
			'31.05.2018 жылға дейін сатып алынған билеттерге 01.06.2018 және 30.06.2018 аралығындағы өтпелі кезең қолданылады. Бұл кезеңде төлем 50 еуроны құрайды.'
	},
	Consents: {
		agreement_gdsRules: '</a> қосымша қызметтердің <a href=\'#\' target=\'_blank\'>шарттарымен',
		agreement_insurancesRules:
			'<a href=\'#\' target=\'_blank\'>сақтандыру ережелерімен</a>, сондай-ақ {{insurancesProductsLinks}} шарттарымен',
		agreement_generalRules: '<span><a href=\'#\' target=\'_blank\'>сатып алу ережелерімен</a></span>',
		agreement_interpolation: '{{generalRules}}{{insurancesRules}}{{additionalServiceRules}}',
		agreement_rules:
			'Мен {{links}}, қосымша қызметтердің ақысын төлеумен таныстым, оларды қабылдаймын және олармен келісемін.',
		agreement_additionalInsuranceRules: '{{link}} жария оферта шарттарымен',
		agreement_additionalInsuranceName: '«{{name}}»'
	},
	Contacts: {
		'Your contacts': 'Контактілер',
		'Contact details are necessary for us to be able to pass on the latest flight information.':
			'Брондау туралы ақпарат алу үшін байланыс деректері қажет',
		Email: 'Эл. пошта',
		Phone: 'Телефон',
		'We sent SMS with verification code to the phone': 'СМС-тегі растау кодын енгізіңіз',
		'Didnt get the code? ': 'Кодты алмадыңыз ба?',
		'Resend it': 'Қайта жіберу',
		Edit: 'Өзгерту',
		'Invalid code.': 'Қате код',
		'Want to speed up passenger data entry? Log in and continue.':
			'Деректерді сақтап, келесі жолы қолмен енгізбеу үшін жүйеге кіріңіз',
		'Want to speed up passenger data entry? Sign up and continue.':
			'Деректерді сақтап, келесі жолы қолмен енгізбеу үшін тіркеліңіз',
		'Want to speed up passenger data entry?': 'Жолаушы деректерін енгізуді жеделдеткіңіз келе ме?',
		'Log in': 'Кіру',
		'Sign up': 'Тіркелу',
		Next: 'Келесі',
		'You can get the new code in': 'Жаңа кодты ... кейін жіберуге болады',
		'Sending message...': 'Код жіберілуде...',
		'Code sent': 'Код жіберілді',
		'Welcome!': 'Қош келдіңіз!',
		'Want to speed up passenger data entry? Sign in and continue.':
			'Брондау процесін жеделдеткіңіз келе ме? Жүйеге кіріңіз.',
		'Continue without signing in': 'Кірусіз жалғастыру',
		'Sign in': 'Кіру',
		'Phone number of the same digits is not allowed': 'Дұрыс телефон нөмірін енгізіңіз',
		'Incorrect phone number': 'Дұрыс телефон нөмірін енгізіңіз',
		'Min 10 digits': 'Кем дегенде 10 сан',
		'Max 18 digits': 'Кем дегенде 18 сан',
		'Example +1234567890': 'Мысалы: +1234567890',
		'Incorrect email': 'Дұрыс эл. пошта мекенжайын енгізіңіз',
		Required: 'Міндетті өріс',
		'Receive a mailing list with promotional offers and discounts':
			'Мен эл. пошта арқылы жеңілдіктер мен ұсыныстары бар жіберілімдерді алуға келісемін'
	},
	CustomerContacts: {
		'Please, enter your contacts': 'Байланыс деректеріңізді енгізіңіз'
	},
	CustomerContactsForm: {
		'Please, enter your contacts': 'Байланыс деректеріңізді енгізіңіз',
		Done: 'Дайын',
		Email: 'Пошта',
		Phone: 'Телефон',
		Required: 'Міндетті өріс',
		'Please enter a valid email': 'Эл. поштаны тексеріңіз',
		'Please enter a valid phone': 'Телефон нөмірін тексеріңіз',
		'Please enter a valid FFP': 'Бейілділік картасының нөмірін тексеріңіз'
	},
	Datepicker: {
		month_0: 'Қаңтар',
		month_1: 'Ақпан',
		month_2: 'Наурыз',
		month_3: 'Сәуір',
		month_4: 'Мамыр',
		month_5: 'Маусым',
		month_6: 'Шілде',
		month_7: 'Тамыз',
		month_8: 'Қыркүйек',
		month_9: 'Қазан',
		month_10: 'Қараша',
		month_11: 'Желтоқсан',
		week_short_0: 'Дс',
		week_short_1: 'Сс',
		week_short_2: 'Ср',
		week_short_3: 'Бс',
		week_short_4: 'Жм',
		week_short_5: 'Сн',
		week_short_6: 'Жк'
	},
	DesktopFlight: {
		Select: 'Таңдау',
		'Select fare': 'Тарифті таңдау',
		Arrival: 'Ұшып келу',
		stop: 'ауысып отыру',
		stops: 'ауысып отыру',
		Nonstop: 'Тікелей',
		Details: 'Толық мәліметтер',
		'Need_f ': 'Қажет',
		'Need_m ': 'Қажет',
		'the ability to refund ticket': 'билетті қайтару мүмкіндігі',
		'the ability to exchange ticket': 'билетті айырбастау мүмкіндігі',
		baggage: 'жолжүк',
		and: ' және'
	},
	DesktopFlightInfo: {
		Terminal: 'Терминал',
		Duration: 'Жолда',
		'Arrival the next day': 'Келесі күні ұшып келу',
		'Eco-friendly': 'Экологиялық таза',
		'Service is unavailable on this flight': 'Бұл рейсте қызмет көрсетілмейді',
		TechnicalLandingIn_0: 'Техникалық қону',
		TechnicalLandingIn_1: 'Техникалық қондырулар',
		'Total duration': 'Жол жүру уақыты',
		'Stop in': '... ауысып отыру',
		'Select from': '… бастап таңдау',
		Select: 'Таңдау',
		from: 'бастап',
		Canceled: 'Бас тартылды',
		'taxes and fees': 'Алымдар',
		'Operating carrier': 'Рейс орындайды',
		SubStatus_AwaitingExchange: 'Айырбастау процесінде',
		SubStatus_Upgrade: 'Қызмет көрсету класын арттыру процесінде'
	},
	DesktopSummaryFlight: {
		'Change flight': 'Басқа рейсті таңдау',
		'Fare rules': 'Тарифті қолдану ережелері',
		'Baggage info': 'Жолжүк туралы ақпарат',
		Details: 'Толық мәліметтер',
		Charter: 'Чартерлік '
	},
	DocumentCardForm: {
		Document: 'Құжат',
		Country: 'Ел',
		'Document type': 'Құжат түрі',
		'Document number': 'Құжат нөмірі',
		'Expiry date': 'Жарамдылық мерзімі',
		Save: 'Сақтау',
		Required: 'Міндетті өріс',
		Remove: 'Жою'
	},
	Exchange: {
		'Change ticket': 'Билетті айырбастау',
		'Successful payment': 'Сәтті төлем',
		'Failed payment': 'Төлем орындалмады',
		'Add new request': 'Жаңа өтінім жасау',
		'Select passengers': 'Жолаушыларды таңдау',
		Back: 'Артқа',
		Next: 'Келесі',
		'Select flights': 'Рейстерді таңдаңыз',
		'Select new flight': 'Жаңа рейсті таңдаңыз',
		'Open calendar': 'Күнді таңдау',
		'You’ve chosen': 'Сіздің таңдауыңыз',
		Clear: 'Тазалау',
		Search: 'Іздеу',
		'Change flight': 'Ұшуды ауыстыру',
		Note: 'Назар аударыңыз',
		'Exchange restrictions': 'Айырбастау шектеулері',
		'The possibility and cost of changes will be calculated by the operator after sending the application. The answer will be sent to your E-mail and is also available on the order page.':
			'Айырбастау мүмкіндігі мен оның құнын оператор сұрау жіберілгеннен кейін есептейді. Жауап эл. поштаңызға жіберіліп, осы бетте көрсетіледі.',
		'After submitting the request, the seats you have selected will be canceled.':
			'Сұрауды жібергеннен кейін рейстегі барлық таңдалған орындар жойылады.',
		'Create request': 'Өтінім жасау',
		Contacts: 'Өтінім жасау',
		'Your name': 'Сіздің атыңыз',
		Email: 'Эл. пошта',
		'I agree with the': 'Мен',
		'Terms of Service': 'қызмет көрсету ережелерімен',
		And: 'және ',
		'Privacy Policy': 'құпиялылық саясатымен келісемін',
		'Your phone': 'Сіздің телефоныңыз',
		'Your comment': 'Сіздің пікіріңіз',
		'I agree to the Terms of Service and Privacy Policy': 'Мен ережелермен келісемін',
		Request: 'Өтінім',
		Create: 'Жасалған',
		'Your comments': 'Сіздің пікіріңіз',
		'The cost of changes will be calculated by the operator after choosing the option and sending the request to the operator.':
			'Айырбастау құнын оператор өтінімді жібергеннен кейін есептейді',
		'Local time indicated': 'Жергілікті уақыт',
		'Order must be paid by {{time}} on {{date}}': 'Тапсырыс {{date}} {{time}} дейін төленуі керек',
		InProcess: 'Орындалуда',
		NeedConfirm: 'Растау күтілуде',
		AwaitingPayment: 'Төлем күтілуде',
		Finished: 'Аяқталды',
		Rejected: 'Қабылданбады',
		Refused: 'Қайтарып алынды',
		TimelimitExpired: 'Төлем уақыты аяқталды',
		'If you change your mind, or want to create a new request with different parameters, delete this request':
			'Ойыңызды өзгертсеңіз немесе жаңа сұрау жасағыңыз келсе, ағымдағысын жойыңыз',
		'Delete request': 'Сұрауды жою',
		'The change request was deleted. Want to create a new request?':
			'Ағымдағы сұрау жойылады. Жаңасын жасауға өтесіз бе?',
		Yes: 'Иә',
		No: 'Жоқ',
		'Limited exchange time': 'Уақыт шегі',
		'Offer valid until {{date}}': 'Ұсыныс {{date}} дейін жарамды',
		'Exchange penalty': 'Айырбастауға арналған айыппұлдар мен алымдар',
		Total: 'Барлығы',
		Required: 'Міндетті өріс',
		'Please, read the rules of service and accept it': 'Ережелерді оқып, келісіңіз',
		'Please enter a valid email': 'Дұрыс эл. поштаны енгізіңіз',
		'Please enter a valid phone': 'Дұрыс телефонды енгізіңіз',
		'Whole flight': 'Бүкіл ұшу',
		'We couldn\'t find any flights for given dates': 'Таңдалған күндерге рейстер табылмады',
		'Please select another date or modify your search. If you wish to purchase a ticket for this particular date, please contact customer support.':
			'Басқа күнді таңдаңыз немесе іздеуді өзгертіңіз. Осы күнге билет сатып алғыңыз келсе, тұтынушыларға қолдау көрсету қызметіне хабарласыңыз.',
		for: 'үшін',
		'Successfully create new booking': 'Жаңа тапсырыс сәтті жасалды',
		'View new booking': 'Байланысты тапсырысты ашу',
		'Request for changes': 'Айырбастау туралы сұрау',
		'Payment exchange': 'Төлеу',
		'Oops...': 'Ой...',
		'{{segmentId}}. {{depDate}}, {{airlineCode}}{{flightNumber}}. {{depIata}}({{depTime}}) -> {{arrIata}}({{arrTime}}). Тариф {{tariff}}':
			'{{segmentId}}. {{depDate}}, {{airlineCode}}{{flightNumber}}. {{depIata}}({{depTime}}) -> {{arrIata}}({{arrTime}}). Тариф: {{tariff}}',
		Refund: 'Қайтаруға',
		'All services issued on one electronic document will be canceled, even if you change itinerary partial. Money refund will be carried out by the airline in accordance with the terms of the Puplic Offer':
			'Бір электрондық құжатта жазылған барлық қызметтер, тіпті сіз бағыттың бір бөлігін айырбастасаңыз да, жойылады. Олар бойынша қаражатты қайтаруды оферта шарттарына сәйкес әуе компаниясы жүзеге асыратын болады.',
		'Select type of change': 'Айырбастау түрін таңдаңыз',
		'Voluntary change': 'Ерікті түрде айырбастау',
		'Involuntary change': 'Еріксіз айырбастау',
		Voluntary: 'Ерікті түрде',
		Involuntary: 'Еріксіз айырбастау',
		'Back to order': 'Тапсырысқа қайту',
		'terms of tariff': 'тариф шарттарымен',
		'Select date for flight {{direction}}': '{{direction}} ұшу күнін таңдаңыз',
		'If you wish to exchange your ticket, please cancel your flight check-in.':
			'Егер билетті айырбастағыңыз келсе, рейске тіркелуден алдын ала бас тартыңыз.',
		'You can do it yourself by going to <a href=\'{{checkInURL}}\' target=\'_blank\'>Online check-in</a>.':
			'Мұны <a href=\'{{checkInURL}}\' target=\'_blank\'>Онлайн тіркелу</a> бөліміне өту арқылы жасауға болады.',
		'Either select unused ticket segments for exchange.':
			'Немесе айырбастау үшін пайдаланылмаған билет сегменттерін таңдаңыз.',
		'It is not possible to exchange the ticket on which the check-in was made for the flight':
			'Рейске тіркеу жүргізілген билетті айырбастау мүмкін емес',
		'It is not possible to exchange a used ticket': 'Пайдаланылған билетті айырбастау мүмкін емес',
		'The ticket has been flown on, you cannot exchange the used ticket':
			'Билет бойынша ұшу жүзеге асырылды, пайдаланылған билетті айырбастауға болмайды.',
		'Partially used ticket can be exchanged only in manual mode':
			'Ішінара пайдаланылған билетті тек қолмен айырбастауға болады',
		'Contact the airline call-center to clarify the conditions of the exchange, as a part of the route was flown. Or select segments of an unused ticket for exchange.':
			'Айырбастау шарттарын нақтылау үшін әуе компаниясының байланыс орталығына хабарласыңыз, себебі бағыттың бір бөлігі бойынша ұшу жүзеге асырылды. Не болмаса айырбастау үшін пайдаланылмаған билет сегменттерін таңдаңыз.',
		'Part of the route was flown, part of the ticket is used. The application for exchange will be considered manually by the airline':
			'Бағыттың бір бөлігі бойынша ұшу жүзеге асырылды, билеттің бір бөлігі пайдаланылған болып табылады. Айырбастауға өтінімді әуе компаниясы өздігінен қарайтын болады',
		'Select new date': 'Жаңа күнді таңдаңыз',
		'Select date': 'Күнді таңдаңыз'
	},
	FareConditions: {
		'Try again': 'Қайталап көру',
		'Internal error': 'Ішкі қате',
		Sheremetyevo: 'Шереметьево',
		Riga: 'Рига',
		Original: 'Түпнұсқа',
		'Translate to russian*': 'Орыс тіліне аудару*',
		'Fare conditions': 'Тариф шарттары',
		'from 12 years': '12 жастан бастап',
		'from 2 to 12 years': '2 жастан 12 жасқа дейін',
		'without seat': 'орынсыз',
		'Fare code': 'Тариф коды',
		'See more details on this page': 'Толығырақ шарттар'
	},
	FareGroup: {
		Select: 'Таңдау',
		Unavailable: 'Қолжетімді емес',
		Recommended: 'Сатылым хиті',
		'Compare fare families': 'Тарифтерді салыстыру',
		Choose: 'Таңдау',
		Rules: 'Ережелер',
		Taxes: 'Алымдар',
		'Not enough miles on your card': 'Картаңызда миль жеткіліксіз'
	},
	FareLock: {
		'Fixation the cost of the air ticket': 'Әуе билетінің құнын бекіту',
		'Check your selection and pay fare lock': 'Таңдауыңызды тексеріп, төлемге өтіңіз',
		'If you make the decision to fly on the selected date within the next {{hours}} {{plural}}, you will be able to pay the full amount of the booking at the fare you locked in. Please, be advised that Fare lock fee is non-refundable.':
			'Таңдалған күні келесі {{hours}} {{plural}} ішінде ұшу туралы шешім қабылдасаңыз, брондаудың толық құнын қатырылған тариф бойынша төлей аласыз. Тарифті қатыру ақысы қайтарылмайтынын ескеріңіз.',
		hours_genitive_0: 'сағаттың',
		hours_genitive_1: 'сағаттың',
		hours_genitive_2: 'сағаттың',
		'No need to worry about the price increase or about the fact that all tickets will be sold out, now you can fix the ticket price for {{hours}} {{plural}}':
			'Бағаның көтерілуі немесе сатылуы туралы алаңдаудың қажеті жоқ, енді {{hours}} {{plural}} әуе билетінің бағасын бекітуге болады.',
		hours_0: 'сағат',
		hours_1: 'сағат',
		hours_2: 'сағат',
		Add: 'Қатыру',
		only: 'Барлығы',
		'Confirmed fare lock': 'Тарифті қатыру'
	},
	FlightCard: {
		Flight: 'Рейс',
		Duration: 'Жолда',
		'The flight operates': 'Рейс орындайды'
	},
	FlightInfo: {
		Details: 'Ұшу туралы толық мәліметтер'
	},
	FlightInfoModalContent: {
		'You choose': 'Сіз ... таңдаңыз',
		'Compare fares': 'Тарифтерді салыстыру',
		'Fare rules': 'Тарифті қолдану ережелері',
		'Select your bundle': 'Тарифті таңдаңыз',
		Economy: 'Эконом',
		Business: 'Бизнес',
		Premium: 'Сыйлықақы',
		'Flight info': 'Ұшу туралы ақпарат',
		'More details': 'Толығырақ мәліметтер',
		'comfortable salon': 'Жайлы салон',
		'access to wifi': 'Wi-Fi қолжетімділігі',
		'View full conditions': 'Тарифтерді салыстыру',
		'hot and children\'s menu': 'Ыстық тамақ',
		'comfortable seating': 'Тегін тіркелу',
		'access to airport lounge': 'Тегін орын таңдау',
		'meals are included in the price': 'Тамақтану қамтылған',
		'premium fare': 'Сыйлықақы тарифтері',
		'Back to flights': 'Ұшуларға қайту',
		'Total duration': 'Жалпы ұзақтығы',
		'Scroll up': 'Жоғары',
		Selected: 'Таңдалған',
		'SelectedFareGroup_View full conditions': 'Тарифтерді салыстыру',
		Back: 'Артқа'
	},
	FlightPrice: {
		from: 'бастап',
		'NO SEATS': 'ОРЫН ЖОҚ',
		Economy: 'Эконом',
		Light: 'Лайт',
		Classic: 'Классик',
		Flex: 'Икемді',
		Business: 'Бизнес',
		Premium: 'Премиум',
		'Select from': 'бастап таңдау',
		Select: 'Таңдау',
		'taxes and fees': 'Алымдар',
		'Subsidized flight': 'Қаражаттандырылған ',
		'A subsidized fare requires all passengers on the booking to have benefits.':
			'Қаражаттандырылған тарифті пайдалану тапсырыстағы барлық жолаушылар жеңілдікке құқылы болған кезде мүмкін болады',
		left: 'қалды',
		left_0: 'қалды',
		tickets: 'билет',
		tickets_1: 'билет',
		tickets_2: 'билет',
		'{{count}} {{ticket}} {{left}}': '{{left}} {{count}} {{ticket}}',
		'Special conditions for flight delays and ticket refunds':
			'Рейсті кешіктіру және билеттерді қайтару кезіндегі ерекше жағдайлар',
		'Full conditions': 'Толық шарттар',
		'Transit tariff': 'Транзиттік тариф'
	},
	FlightSortFilter: {
		Sort: 'Сұрыптау',
		'Price Graph': 'Бағалар кестесі'
	},
	FlightsListControls: {
		Filter: 'Іздеу',
		Nonstop: 'Ауысып отыру жоқ',
		'Flight Num': 'Ұшу нөмірі',
		'Enter airline code or flight number': 'Әуе компаниясының кодын немесе ұшу нөмірін енгізіңіз',
		Schedule: 'Кесте'
	},
	Forms: {
		Search: 'Іздеу',
		'My booking': 'Брондауға қолжетімділік',
		Checkin: 'Онлайн тіркелу',
		'Ticket number': 'Билет нөмірі',
		'Order number': 'Билет немесе тапсырыс нөмірі',
		'Last name': 'Жолаушының тегі',
		Find: 'Табу',
		Continue: 'Жалғастыру',
		'To check in for a Smartavia flight, please visit their official website':
			'Smartavia рейсіне тіркелу үшін олардың ресми веб-сайтына кіріңіз'
	},
	FullscreenDialog: {
		Close: 'Жабу'
	},
	GuardedApolloProvider: {
		'Ops...': 'Мәә...',
		'Unfortunately, something went wrong. Please try again or contact with us':
			'Өкінішке орай, бірдеңе дұрыс болмады. Әрекетті кейінірек қайталап көріңіз',
		Close: 'Жабу',
		'The service is temporarily unavailable. It is possible that the order is open on another device/browser or being handled by an airline specialist. Please try again later.':
			'Қызмет уақытша қолжетімді емес, тапсырыс басқа құрылғыда/шолғышта ашылуы немесе онымен әуе компаниясының маманы жұмыс істеп жатқан болуы мүмкін. Әрекетті кейінірек қайталап көріңіз.'
	},
	IncludedBaggage: {
		Included: 'Қамтылған',
		there: 'бару',
		return: 'қайту',
		'round trip': 'барлық рейстерге',
		Upgrade: 'Жақсарту',
		included: 'Қамтылған',
		'Whole route': 'Бүкіл жол',
		'Choose for each flight': 'Әр рейске бөлек',
		'Price per flight': 'Ұшу бағасы',
		'Price for all flights': 'Толық ұшудың бағасы',
		Cancel: 'Бас тарту',
		Confirm: 'Растау',
		Total: 'Барлығы',
		Clear: 'Тазалау',
		'Added for all flights': 'Бүкіл бағыт бойынша',
		Equipment: 'Жабдық',
		'Need to bring sports, music or baby equipments?':
			'Өзіңізбен бірге спорттық, музыкалық жабдық немесе балалар бесік арбасын алып жүру қажет пе?',
		'All flights': 'барлық рейстер',
		from: 'бастап',
		total: 'барлығы',
		Edit: 'Өзгерту',
		Add: 'Қосу',
		'Up to': 'Дейін'
	},
	IncludedOptions: {
		Included: 'Қамтылған',
		'Baggage rules': 'Жолжүкті алып жүру ережелері',
		'Upgrade cabin baggage': 'Қол жүк',
		'Get {{upgradedCabinBaggage}} of cabin baggage onboard, instead of {{includedCabinBaggage}}':
			'{{includedCabinBaggage}} орнына {{upgradedCabinBaggage}} қол жүгі',
		pc: 'д.',
		kg: 'кг',
		with: 'тариф',
		Change: 'Өзгерту',
		Upgrade: 'Қосу'
	},
	InfoCard: {
		document: 'Құжат',
		'Frequent Flyer programm': 'Бейілділік картасы',
		passport: 'Төлқұжат',
		'International passport': 'Шетелдік төлқұжат',
		Number: 'Нөмір',
		'Expiry date': 'Жарамдылық мерзімі',
		Delete: 'Жою',
		Edit: 'Өңдеу',
		Add: 'Қосу',
		'dd.mm.yyyy': 'кк.аа.жжжж'
	},
	InsurancePage: {
		'You lose protection and peace of mind in unforeseen situations.': 'Сақтандыру таңдалмаған',
		'Buy insurance': 'Сақтандыру төлемдерін алу',
		'I assume all risks and Cancel insurance': 'Сақтандыру төлемдерінен бас тартамын',
		'Insure your flight': 'Сақтандыруды таңдау керек',
		'To make your travels memorable only with pleasant excitement, take out an insurance policy that will protect you during your trip.':
			'Саяхаттарыңыз тек жағымды толқулармен есте қалуы үшін сапар кезінде сізді қорғайтын сақтандыру полисін рәсімдеңіз.',
		'For all passengers': 'Барлық жолаушылар үшін',
		Remove: 'Жою',
		from: 'бастап',
		'I want protect my trip.': 'Мен сақтандыру жағдайында төлем алғым келеді',
		'I do not want to insure my life or luggage and assume all risks':
			'Сақтандырусыз ұшу. Күтпеген жағдайларға байланысты барлық шығындарды өзім төлеймін',
		'More details': 'Толық мәліметтер',
		'Choice of insurance': 'Сақтандыруды таңдау',
		'Back to services': 'Қызметтерге қайту',
		Cancel: 'Бас тарту',
		Confirm: 'Растау',
		InsuranceUpsaleMainDescription:
			'Жолжүк мәселесі, рейстің кешігуі немесе тоқтатылуы, сондай-ақ қосымша медициналық шығындар немесе жазатайым оқиға болған жағдайда төлем ала алмайсыз.',
		InsuranceUpsaleAdditionalDescription:
			'Орташа алғанда, сақтандыру полисінің құны күтпеген жағдайлар туындаған жағдайда ықтимал шығындардың 0,1%-ын құрайды. Тәжірибелі саяхатшылар сапардың мақсаттарына назар аудару және қажетсіз шығындардан құтылу үшін сақтандыруды үнемі сатып алады.',
		'Most popular': 'Жолаушыларды таңдау',
		'Download police': 'Полисті жүктеп алу',
		Add: 'Қосу'
	},
	Loader: {
		loading: 'жүктеу'
	},
	Location: {
		Terminal: 'Терминал',
		Details: 'Толық мәліметтер'
	},
	LocationAutocomplete: {
		'Recent searches': 'Іздеген нәрсеңіз',
		'show all directions': 'барлығын көрсету',
		'Sorry, we do not fly': 'Рейстер жоқ',
		from: 'ішінен',
		to: 'ішіне',
		'Nearby airports': 'Ең жақын әуежайлар',
		'Popular airports': 'Танымал бағыттар',
		'Perhaps you are looking for': 'Мүмкін іздеген боларсыз',
		Stop_0: 'Ауысып отыру',
		Stop_1: 'Ауысып отыру',
		Stop_2: 'Ауысып отыру',
		From: 'Қайдан',
		To: 'Қайда',
		'Enter city or country': 'Қаланы немесе елді енгізіңіз',
		'Pick a country': 'Елді таңдаңыз',
		'Pick a city': 'Қаланы таңдаңыз'
	},
	LoginPage: {
		'Log in': 'Кіру',
		Required: 'Міндетті өріс',
		'Please enter a valid Email / Phone / Card number': 'Эл. поштаны/телефонды/карта нөмірін енгізіңіз',
		'Email / Phone / Card number': 'Эл. пошта/телефон/карта нөмірі',
		'or with you social network': 'әлеуметтік желілер арқылы кіру',
		'Please, read the rules of service and accept it':
			'Жалғастыру үшін жеке деректерді өңдеуге келісіміңізді растаңыз',
		'Welcome!': 'Қош келдіңіз!',
		'You are logged in for the first time, please read the terms and conditions and give consent':
			'Сіз жүйеге алғаш рет кірдіңіз, шарттармен танысып, жеке деректерді өңдеуге келісіміңізді растаңыз',
		'I agree to the': 'Мен',
		'Terms of Service and Privacy Policy': 'жеке деректерімді өңдеуге келісім беремін',
		'An e-mail with code has been sent to you.': 'Сізге коды бар хат жіберілді.',
		'Code sent to your phone.': 'Код телефоныңызға жіберілді.',
		'Please, check the code': 'Енгізілген кодтың дұрыстығын тексеріңіз',
		'Didn\'t get the code?': 'Кодты алмадыңыз ба?',
		'Resend it': 'Кодты қайта жіберу',
		'Welcome back,': 'Қош келдіңіз,',
		'Welcome back!': 'Қош келдіңіз!',
		'Enter code': 'Растау кодын енгізіңіз',
		'Verification code': 'Растау коды',
		Continue: 'Жалғастыру',
		'Enter code_FFP': 'Құпиясөзді енгізіңіз',
		'Verification code_FFP': 'Құпиясөз',
		Continue_FFP: 'Кіру',
		'Enter code_Email': 'Растау кодын енгізіңіз',
		'Verification code_Email': 'Растау коды',
		Continue_Email: 'Жалғастыру',
		'Enter code_Phone': 'Растау кодын енгізіңіз',
		'Verification code_Phone': 'Растау коды',
		Continue_Phone: 'Жалғастыру',
		'If you don\'t have an account, it will be created automatically':
			'Егер сізде тіркелгі болмаса, ол автоматты түрде жасалады',
		'Remember me': 'Мені есте сақтау'
	},
	Loyalty: {
		'Log in to LightJet Club': 'Websky Club жеке кабинетіне кіру',
		'Forgot password?': 'Құпиясөзді ұмыттыңыз ба?',
		Step: 'Қадам',
		'Enter your email': 'Эл. поштаңызды енгізіңіз',
		Back: 'Артқа',
		Continue: 'Жалғастыру',
		'Profile not found. Check spelling your e-mail address':
			'Профиль табылмады. Эл. поштаның дұрыстығын тексеріңіз',
		'Enter code': 'Кодты енгізіңіз',
		'The verification code has been sent to the email': 'Растау коды эл. поштаға жіберілді',
		'Verification code': 'Кілт',
		'You entered an incorrect code': 'Қате код',
		'Password reset': 'Құпиясөз өзгертілді',
		'A new password has been sent to your e-mail': 'Жаңа құпиясөз сіздің эл. поштаңызға жіберілді',
		'Back to login': 'Кіру',
		Required: 'Міндетті өріс',
		'Card number': 'Карта нөмірі',
		Password: 'Құпиясөз',
		'Not a member yet? Join for free!': 'Картаңыз әлі жоқ па? Тегін тіркеліңіз!',
		'Create account': 'Тіркелгіні жасау',
		'I have a card': 'Менде карта бар',
		Create: 'Жасау',
		'Data was sent to your email': 'Деректер поштаға жіберілді',
		'You successfully created account. Check your email to sign in':
			'Сіз бейілділік бағдарламасында тіркелгіні сәтті жасадыңыз. Жүйеге кіру мәліметтері электрондық поштаңызға жіберілді.',
		'Log in to account': 'Тіркелгіге кіру',
		'Your status': 'Сіздің күйіңіз',
		'Ops...': 'Ой...',
		'Connect to loyalty program with your card': 'Профиліңізді бейілділік бағдарламасына қосыңыз',
		'Incorrect card number or password': 'Карта нөмірі немесе құпиясөз дұрыс емес',
		'Please enter your card number': 'Міндетті өріс',
		'Enter password': 'Міндетті өріс',
		red: 'Red',
		silver: 'Silver',
		gold: 'Gold',
		platinum: 'Platinum',
		miles: 'миль',
		'miles left for': 'дейін миль қалды',
		'Left for gold status': 'Алтын күйге дейін',
		'Left for silver status': 'Күміс күйге дейін',
		'Left for platinum status': 'Платина күйіне дейін',
		About: 'Толығырақ',
		'Miles recovery': 'Ұшуларды қалпына келтіру',
		'Use miles': 'Мильдерді пайдалану',
		Promotions: 'Акциялар',
		'Promo-code': 'Промо-кодтар',
		'E-voucher': 'Купон',
		expiry: 'мерзімі аяқталуда',
		expired: 'мерзімі аяқталды',
		Connect: 'Қосу',
		'Get promo code': 'Промокодты алу',
		Get: 'Алу',
		Conditions: 'Шарттар',
		'How to get': 'Алу жолы',
		'How to use': 'Пайдалану жолы',
		Active: 'Белсенді',
		Expired: 'Мерзімі аяқталған',
		Total: 'Барлығы',
		'Exit and add another card': 'Жүйеден шығып, басқа картаны қосу',
		'You sure?': 'Сенімдісіз бе?',
		'Delete card from your account?': 'Картаны тіркелгіңізден жою қажет пе?',
		No: 'Жоқ',
		Yes: 'Иә',
		or: 'немесе',
		flights: 'ұшулар',
		'Cannot create an account': 'Тіркелгіні жасау қатесі',
		'Registration of persons under the age of 14 in the loyalty program is prohibited':
			'Бейілділік бағдарламасында тек 14 жастан бастап тіркелуге болады',
		Close: 'Жабу',
		'out of': 'ішінен',
		'Left {{miles}} for {{level}} status': '{{level}} күйіне дейін {{miles}} қалды',
		'Start saving now': 'Үнемдеуді қазір бастаңыз!\nМильдер табыңыз және оларды жақын арадағы рейстерге жұмсаңыз.',
		Registration: 'Тіркеу',
		Statuses: 'Күйлер',
		Earn: 'Жинау',
		'Earn miles': 'Мильдерді жинау',
		Status: 'Күй',
		Use: 'Жұмсау',
		FAQ: 'Жиі қойылатын сұрақтар',
		'Please wait, we are updating information about your loyalty card. It make take a  few minutes...':
			'Күте тұрыңыз, бейілділік картаңыз туралы ақпаратты жаңартып жатырмыз. Бұл бірнеше минут алуы мүмкін',
		'To continue registering in the loyalty system, fill out and confirm your email in your personal account.':
			'Бейілділік жүйесінде тіркелуді жалғастыру үшін жеке кабинетіңізде электрондық поштаңызды толтырып, растаңыз.',
		'Fill email': 'Поштаны толтыру',
		'This auth type is already being used in another account': 'Бұл карта басқа тіркелгіде пайдаланылуда',
		'The use of a loyalty card is prohibited': 'Бұл картаны пайдалануға тыйым салынған'
	},
	LoyaltyBonus: {
		'LightJet Club': 'Websky Club',
		miles: 'миль',
		'You will get for this flight': 'Сіз осы ұшу үшін ... аласыз',
		'Fly with us and get bonuses!': 'Бізбен бірге ұшып, бонустар алыңыз!'
	},
	LoyaltyCardForm: {
		'Frequent Flyer': 'Бейілділік картасы',
		'Frequent Flyer Programm': 'Бейілділік картасының бағдарламалары',
		'Document number': 'Нөмір',
		Save: 'Сақтау',
		Required: 'Міндетті өріс'
	},
	Meal: {
		Add: 'Қосу',
		Select: 'Таңдау',
		Clear: 'Тазалау',
		Done: 'Дайын',
		g: 'г',
		Allergens: 'Аллергендер',
		Free: 'Тегін',
		'Show description': 'Толығырақ',
		Total: 'Барлығы',
		'Add for all': 'Барлығына қосу'
	},
	MealPage: {
		'Meals on board': 'Борттағы тамақтану',
		'Feel the taste in flight': 'Ұшудан ләззат алыңыз\n\n',
		Meal: 'Тамақтану'
	},
	MealService: {
		All: 'Барлық тағамдар',
		'Select menu': 'Мәзірді таңдаңыз',
		serving_0: '{{count}} порция',
		serving_1: '{{count}} порция',
		serving_2: '{{count}} порция',
		select: 'таңдау',
		'Terms & conditions': 'Тамақтану опциясын қамтамасыз ету шарттары',
		Unavailable: 'Қолжетімді емес',
		'Selected dishes': 'Таңдалған тағамдар'
	},
	MetasearchLoader: {
		'Checking seats availability': 'Бос орындардың қолжетімділігін тексереміз',
		'Just a few seconds...': 'Бұл бірнеше секундқа созылады...',
		'Booking service is temporary unavailable': 'Брондау қызметі уақытша қолжетімді емес',
		'Please reload the page': 'Бетті жаңартыңыз',
		Reload: 'Жаңарту'
	},
	MilesRecovery: {
		'Miles recovery': 'Мильді қалпына келтіру',
		'Please note that miles recovery is possible': 'Мильді қалпына келтіру мүмкін екенін ескеріңіз:',
		MoreThanSixMonthsFlights: 'Тек бұрыннан орындалған ұшулар',
		OnlyCompletedFlights: '6 айдан аспайтын бұрын орындалған ұшулар үшін',
		'Ticket number': 'Билет нөмірі',
		Create: 'Өтінім жасау',
		'Passenger surname': 'Жолаушының тегі',
		Required: 'Міндетті өріс',
		'Order not found': 'Тапсырыс табылмады',
		'Enter your ticket number': 'Билет нөмірін енгізіңіз',
		'Invalid date': 'Дұрыс күнді енгізіңіз',
		'Flight date': 'Ұшулар күні',
		'Flight number': 'Рейс нөмірі',
		'Pick a flight date': 'Рейс күнін таңдаңыз'
	},
	MobileAuthForm: {
		'Sign in': 'Жүйеге кіріңіз',
		'and fill in passengers info with a single click':
			'және жолаушылардың деректерін бір рет басу арқылы енгізіңіз',
		'Sign in with email': 'Эл. пошта арқылы кіру',
		'Continue as a guest': 'Қонақ ретінде жалғастыру'
	},
	MobileSegmentInfo: {
		Nonstop: 'Тікелей',
		'More info': 'Толығырақ',
		stop: 'ауысып отыру',
		in: 'ішіне',
		Terminal: 'Терминал'
	},
	MobileSelectedFare: {
		'You selected': 'Сіз ... таңдаңыз',
		'Compare fare families': 'Тарифтерді салыстыру',
		'Fare conditions': 'Тариф шарттары',
		Free: 'Тегін',
		'Fare rules': 'Тарифті қолдану ережелері',
		'Baggage info': 'Жолжүк туралы ақпарат'
	},
	MobileStepbar: {
		Flights: 'Ұшу',
		Passengers: 'Жолаушылар',
		'Onboard Services': 'Борттағы қызметтер',
		Extras: 'Қосымша қызметтер',
		Payment: 'Төлем',
		Add: 'Қосу',
		Total: 'Барлығы',
		Economy: 'Эконом класс',
		Business: 'Бизнес класс',
		Adult: 'Ересек',
		Child: 'Бала',
		Infant: 'Нәресте',
		'Infant with seat': 'Орны бар нәресте',
		Details: 'Толық мәліметтер',
		Change: 'Өзгерту',
		ADT: 'Ересек',
		CLD: 'Бала',
		INF: 'Нәресте',
		INS: 'Орны бар нәресте',
		M: 'Ер адам',
		F: 'Әйел адам',
		Contact: 'Контактілер',
		'Not selected': 'Таңдалмаған',
		Free: 'Тегін'
	},
	MobileSummaryFlight: {
		Returning: 'Қайту',
		Departing: 'Бару',
		'taxes and fees': 'Алымдар'
	},
	MobileToolbar: {
		Back: 'Артқа',
		Continue: 'Жалғастыру'
	},
	OrderCard: {
		'Booking ID': 'Брондау коды',
		Open: 'Ашу',
		'Security code': 'Кіру коды',
		Passengers: 'Жолаушылар',
		Details: 'Толық мәліметтер',
		Transactions: 'Транзакциялар',
		Download: 'Жүктеп алу',
		Confirmed: 'Төленді',
		'The order must be paid today': 'Төлемді бүгін ... дейін күтеді',
		'The order must be paid at': 'Төлемді ... дейін күтеді',
		'Online check-in started': 'Онлайн тіркелу ашық',
		'Tickets have been sent to {{email}}': 'Билеттер {{email}} мекенжайына жіберілді',
		'Send tickets to the email?': 'Билеттерді поштаға жіберу қажет пе?',
		Booked: 'Брондалды',
		Cancelled: 'Бас тартылды',
		Total: 'Барлығы',
		'Changed your plans?': 'Жоспарларыңыз өзгерді ме?',
		Exchange: 'Айырбастау',
		Refund: 'Қайтару',
		'Review:Waiting for payment': 'Төлем күтілуде',
		'Review:Expires at': 'мерзімі аяқталуда',
		'Review:Expires today at': '... мерзімі аяқталады',
		'Account:Waiting for payment': 'Төлем күтілуде',
		'Account:expires at': 'Мерзімі аяқталуда',
		'Account:expires today at': '... мерзімі аяқталады',
		'Check-in': 'Онлайн тіркелу',
		'Resend it': 'Қайта жіберу',
		'Passengers details': 'Жолаушылар туралы ақпарат',
		'Expired date': 'Жарамдылық мерзімі',
		Gender_male: 'Ерлер',
		Gender_female: 'Әйелдер',
		'Additional information': 'Қосымша ақпарат',
		Accompanying: 'Алып жүруші',
		accompanies: 'Алып жүру',
		'Select an adult for accompany': 'Алып жүруші ересек адамды таңдаңыз',
		'After selecting a new adult, please double-check all services. Please choose an adult who does not sit on the emergency seat row.':
			'Жаңа ересек адамды таңдағаннан кейін барлық тапсырыс берілген қызметтерді қайта тексеріңіз. Апаттық қатарда отырмайтын ересек адамды таңдаңыз.',
		Confirm: 'Растау',
		'Change link to adult': 'Ересек адамға байланыстыруды өзгерту',
		'Oops...': 'Ой...',
		'An error occurred while executing the request. Please try again later or contact a customer support service.':
			'Сұрауды орындау кезінде қате пайда болды. Әрекетті қайталаңыз немесе тұтынушыларға қолдау көрсету қызметіне хабарласыңыз.',
		OK: 'OK',
		DeleteFromList: 'Тізімнен жою',
		BookingRemoval: 'Брондауды жою',
		BookingRemovalMessage: '{{orderLocator}} брондау тізімнен жойылады',
		Remove: 'Жою',
		Cancel: 'Бас тарту'
	},
	OrderChangeHistoryModal: {
		History: 'Тарихы',
		'Loading...': 'Жүктеу...',
		'History is empty': 'Тарихы бос',
		Time: 'Күні/уақыты',
		Action: 'Әрекет'
	},
	OrderSummary: {
		Booking: 'Брондау коды',
		'Security code': 'Кіру коды',
		from: 'ішінен',
		to: 'ішіне',
		Manage: 'Қарап шығу',
		'Currently there are no active bookings made through your private profile.':
			'Сіз әлі бірде-бір брондау жасамадыңыз.',
		'Search flight': 'Рейстерді іздеу',
		'I have a booking': 'Тапсырысты қосу',
		'Check-in': 'Онлайн тіркелу',
		Download: 'Жүктеп алу',
		'For accessing booking page from another device': 'Басқа құрылғыдан тапсырысқа кіру рұқсатын алу үшін',
		'Waiting for payment': 'Төлеу қажет',
		'expires at': 'дейін',
		'expires today at': 'бүгін ... дейін',
		'Time to complete booking has expired': 'Төлем уақыты аяқталды'
	},
	Page404: {
		'Destination unknown': 'Біз мұнда ұшпаймыз',
		'PAGE NOT FOUND': 'БЕТ ТАБЫЛМАДЫ',
		'Take me home': 'Басты бетке оралу'
	},
	Passenger: {
		Adult: 'Ересек',
		Child: 'Бала',
		Infant: 'Нәресте',
		'Infant with seat': 'Орны бар нәресте',
		phone: 'Телефон',
		email: 'Эл. пошта',
		latinFirstName: 'Аты (латын әріптерімен)',
		latinLastName: 'Тегі (латын әріптерімен)',
		latinMiddleName: 'Әкесінің аты (латын әріптерімен)',
		docIssued: 'Құжаттың берілген күні',
		docIssuedBy: 'Құжатты берген ұйымның коды',
		city: 'Қала',
		country: 'Ел',
		firstName: 'Аты',
		lastName: 'Тегі',
		middleName: 'Әкесінің аты',
		birthDate: 'Туған күні',
		gender: 'Жынысы',
		nationality: 'Азаматтығы',
		docType: 'Құжат түрі',
		docNumber: 'Құжат нөмірі',
		docExpiryDate: 'Жарамдылық мерзімі',
		loyaltyName: 'Бейілділік картасы',
		loyaltyNumber: 'Бейілділік картасының нөмірі',
		Passenger: 'Жолаушы',
		'Onboard services': 'Борттағы қызметтер',
		'Latin symbols and digits': 'Латын әріптері мен сандары',
		'Enter date in dd.mm.yyyy format': 'Дұрыс күнді енгізіңіз',
		'Incorrect date': 'Қате күн',
		'Date expired': 'Жарамдылық мерзімі өтті',
		Edit: 'Өзгерту',
		Required: 'Міндетті өріс',
		Passport: 'Төлқұжат',
		MilitaryIDCard: 'Әскери билет',
		DocOfPassportLusing: 'Уақытша жеке куәлік',
		'ReleaseCertificate ': 'Босатылған тұлғалар үшін босату туралы анықтама',
		'ServicePassport ': 'Қызметтік төлқұжат',
		'FederalParliamentDeputy ': 'Федерациялар кеңесі немесе мемлекеттік дума депутатының куәлігі',
		DiplomaticPassport: 'Дипломатиялық төлқұжат',
		InternationalPassportNotRU: 'Шетелдік төлқұжат',
		InternationalPassportRU: 'Шетелдік төлқұжат',
		InternationalPassport: 'Шетелдік төлқұжат',
		NationalPassport: 'Ұлттық төлқұжат',
		SeamanDocument: 'Теңізшінің төлқұжаты',
		SeniorDocument: 'Зейнетақы куәлігі',
		BirthRegDocument: 'Туу туралы куәлік',
		CertificateOfConvictedVacation: 'Жеке куәлік',
		ResidencePermit: 'Тұруға ықтиярхат',
		'Only letters are allowed': 'Жарамсыз таңбалар енгізілді',
		'Phone number of the same digits is not allowed': 'Дұрыс телефон нөмірін енгізіңіз',
		'Incorrect phone number': 'Дұрыс телефон нөмірін енгізіңіз',
		'Min 10 digits': 'Кем дегенде 10 сан',
		'Max 18 digits': 'Кем дегенде 18 сан',
		'Example +1234567890': 'Мысалы: +1234567890',
		'Only digits': 'Тек сандар',
		'11 digits': '11 санды енгізіңіз',
		'10 digits': '10 санды енгізіңіз',
		'9 digits': '9 санды енгізіңіз',
		'No less then 5 digits': '5 саннан кем емес',
		'Incorrect email': 'Дұрыс эл. пошта мекенжайын енгізіңіз',
		'Invalid date format': 'Дұрыс күнді енгізіңіз',
		'Example: IVШЯ123123': 'Мысалы: IVШЯ123123',
		'Example: IIIШЯ352007, 5465467': 'Мысалы: IIIШЯ352007, 5465467',
		'Example: AN0123456': 'Мысалы: AN0123456',
		'Cyrillic symbols are not allowed': 'Тек латын әріптері',
		identity: 'Жолаушының деректері',
		citizenship: 'Құжат',
		loyalty: 'Бейілділік бағдарламасы',
		contacts: 'Контактілер',
		'Don\'t have a card yet? Register now.': 'Бағдарламаға қатыспайсыз ба? Тіркеліңіз.',
		'Check if the input is correct': 'Енгізудің дұрыстығын тексеріңіз',
		other: 'Басқа',
		organizationName: 'Ұйымның атауы',
		personnelNumber: 'Табельдік нөмір',
		'A subsidized fare requires all passengers on the booking to have benefits.':
			'Қаражаттандырылған тарифті пайдалану тапсырыстағы барлық жолаушылар жеңілдікке құқылы болған кезде мүмкін болады',
		'I have a loyalty card': 'Менде бейілділік картасы бар',
		'Don\'t have a card yet?': 'Бағдарламаға қатыспайсыз ба?',
		'Register now': 'Тіркеліңіз',
		Male: 'Ер адам',
		Female: 'Әйел адам',
		Cancel: 'Бас тарту',
		Confirm: 'Растау',
		'Please, check passenger data': 'Жолаушының деректерін тексеріңіз',
		promoCode: 'Промокод',
		'Passenger with disabilities': 'Мүмкіндігі шектеулі жолаушы',
		'Passengers with disabilities and other persons with reduced mobility and persons accompanying them shall board the aircraft before boarding':
			'Мүмкіндіктері шектеулі жолаушылар және қозғалысы шектеулі басқа да адамдар, сондай-ақ оларды алып жүруші тұлғалар қону алдында әуе кемесінің бортына көтерілуге тиіс',
		'Booking details of the accompanying passenger': 'Алып жүруші жолаушының брондау деректері',
		'Fill in the fields with the booking details of the accompanying passenger over 18 years of age. Please note that the flight dates, flight and class of service for both passengers must be the same.':
			'18 жастан асқан алып жүруші жолаушының брондау деректері бар өрістерді толтырыңыз. Ұшу күндері, рейс және қызмет көрсету класы екі жолаушы үшін бірдей болуы керек екенін ескеріңіз.',
		'I confirm that the provided ticket number and the name of the accompanying passenger are correct and valid.':
			'Ұсынылған әуе билетінің нөмірі мен алып жүруші жолаушының толық аты-жөні дұрыс жазылғанын және жарамды екенін растаймын.',
		accompanyingPersonName: 'Алып жүруші жолаушының толық аты-жөні ',
		accompanyingPersonTicketNumber: 'Әуе билетінің нөмірі',
		'13 digits': '13 санды енгізіңіз',
		'Select at least one service from the list below': 'Тізімнен қызметті таңдаңыз',
		linkedTraveller: 'Алып жүруші',
		'Popular countries': 'Танымал елдер',
		'Other countries': 'Барлық елдер'
	},
	PassengerSubsidy: {
		'Subsidies not available': 'Көмекқаржылар қолжетімді емес',
		'A subsidized fare requires all passengers on the booking to have benefits.':
			'Қаражаттандырылған тарифті пайдалану тапсырыстағы барлық жолаушылар жеңілдікке құқылы болған кезде мүмкін болады',
		'Edit passengers data': 'Өңдеуге оралу',
		'New search': 'Жаңа іздеу',
		Attention: 'Назар аударыңыз'
	},
	PassengerTypes: {
		Adult: 'Ересек',
		Adult_0: 'Ересек',
		Adult_1: 'Ересек',
		Adult_2: 'Ересек',
		ADT: 'Ересек',
		ADT_0: 'Ересек',
		ADT_1: 'Ересек',
		ADT_2: 'Ересек',
		AAT: 'Ересек',
		AAT_0: 'Ересек',
		AAT_1: 'Ересек',
		AAT_2: 'Ересек',
		Child: 'Бала',
		Child_0: 'Бала',
		Child_1: 'Бала',
		Child_2: 'Балалар',
		CLD: 'Бала',
		CLD_0: 'Бала',
		CLD_1: 'Бала',
		CLD_2: 'Балалар',
		CNN: 'Бала',
		CNN_0: 'Бала',
		CNN_1: 'Бала',
		CNN_2: 'Балалар',
		CTN: 'Бала',
		CTN_0: 'Бала',
		CTN_1: 'Бала',
		CTN_2: 'Балалар',
		CHD: 'Бала',
		CHD_0: 'Бала',
		CHD_1: 'Бала',
		CHD_2: 'Балалар',
		Infant: 'Нәресте',
		Infant_0: 'Нәресте',
		Infant_1: 'Нәресте',
		Infant_2: 'Нәрестелер',
		INF: 'Нәресте',
		INF_0: 'Нәресте',
		INF_1: 'Нәресте',
		INF_2: 'Нәрестелер',
		'Infant with seat': 'Орны бар нәресте',
		'Infant with seat_0': 'Орны бар нәресте',
		'Infant with seat_1': 'Орны бар нәресте',
		'Infant with seat_2': 'Орны бар нәресте',
		INS: 'Орны бар нәресте',
		INS_0: 'Орны бар нәресте',
		INS_1: 'Орны бар нәресте',
		INS_2: 'Орны бар нәресте',
		YTH: 'Жастар',
		YTH_0: 'Жастар',
		YTH_1: 'Жастар',
		YTH_2: 'Жастар',
		SCF: 'Зейнеткер (әйелдер)',
		SCF_0: 'Зейнеткер (әйелдер)',
		SCF_1: 'Зейнеткер (әйелдер)',
		SCF_2: 'Зейнеткерлер (ерлер)',
		SCM: 'Зейнеткер (ерлер)',
		SCM_0: 'Зейнеткер (ерлер)',
		SCM_1: 'Зейнеткер (ерлер)',
		SCM_2: 'Зейнеткерлер (ерлер)',
		РВТ: 'Орны бар нәресте',
		РВТ_0: 'Орны бар нәресте',
		РВТ_1: 'Орны бар нәресте',
		РВТ_2: 'Орны бар нәресте',
		SRC: 'Зейнеткер',
		SRC_0: 'Зейнеткер',
		SRC_1: 'Зейнеткер',
		SRC_2: 'Зейнеткерлер'
	},
	Passengers: {
		Adults: 'Ересектер',
		Teenagers: 'Жасөспірімдер',
		Children: 'Балалар',
		'Latin symbols and digits': 'Латын әріптері мен сандары',
		Infants: 'Нәрестелер',
		'Infants with seat': 'Орны бар нәрестелер',
		'Young adult': 'Жастар',
		'Senior (men)': 'Зейнеткерлер (ерлер)',
		'Senior (female)': 'Зейнеткерлер (әйелдер)',
		'12-23 years': '12-23 жас',
		'12-18 years': '12-18 жас',
		'55+ years': '55+ жас',
		'60+ years': '60+ жас',
		'12+ years': '12+ жас',
		'2-11 years': '2-11 жас',
		'Up to 2 years': '2 жасқа дейін',
		'Add other categories': 'Басқа санаттар',
		'Adults over twelve years old': 'Он екі жастан асқан ересектер',
		'Young peoples from twelve to eighteen years old': '12 жастан 18 жасқа дейінгі жастар',
		'Children from two to eleven years old': 'Екі жастан он бір жасқа дейінгі балалар',
		'Infants up to two years old, without seat': 'Екі жасқа дейінгі нәрестелер, орны жоқ',
		'Infants up to two years old, with seat': 'Екі жасқа дейінгі нәрестелер, орны бар',
		'Young peoples 12-23 years old': 'Он екіден жиырма үш жасқа дейінгі жастар',
		'Young peoples 12-18 years old': '12 жастан 18 жасқа дейінгі жастар',
		'Senior men up 60 years': '60 жастан асқан ер адамдар',
		'Senior women up 55 years': '55 жастан асқан әйелдер',
		'Please notice, you must receive your boarding passes at the airport':
			'Отырғызу талондарын тек әуежайда алуға болатынын ескеріңіз.',
		'Senior men up 60 years, Senior women up 55 years':
			'Зейнеткерлер 60 жастан асқан ер адамдар, 55 жастан асқан әйелдер',
		Senior: 'Зейнеткерлер',
		'men 60+ female 55+': 'Е 60+ Ә 55+'
	},
	PaymentErrors: {
		'An error occurred while executing the request': 'Сұрауды орындау кезінде қате пайда болды.',
		'Please try again later or contact a customer support service':
			'Әрекетті қайталаңыз немесе тұтынушыларға қолдау көрсету қызметіне хабарласыңыз.',
		Error: 'Қате',
		OK: 'OK',
		Sirena2_already_processed: 'Тапсырыс төленген',
		Sirena2_access_denied:
			'Төлем жүйесіне қосылу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, access_denied қате кодын хабарлаңыз.',
		Sirena2_system_error: 'Төлем жүйесіне қосылу мүмкін болмады. Бетті жаңартыңыз.',
		Sirena2_fatal_error: 'Төлем жүйесіне қосылу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласыңыз.',
		Sirena2_order_error:
			'Тапсырысты өңдеу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, order_error қате кодын хабарлаңыз.',
		Sirena2_invalid_order:
			'Тапсырысты табу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, invalid_order қате кодын хабарлаңыз.',
		Sirena2_pricing_error:
			'Тапсырысты өңдеу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, pricing_error қате кодын хабарлаңыз.',
		Sirena2_booking_error:
			'Тапсырысты өңдеу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, booking_error қате кодын хабарлаңыз.',
		Sirena2_wrong_amount:
			'Қате тапсырыс құны. Бетті жаңартыңыз немесе техникалық қолдау көрсету қызметіне хабарласыңыз.',
		Sirena2_session_error: 'Төлем процесін бастау мүмкін болмады. Бетті жаңартыңыз.',
		Sirena2_max_attempts: 'Тапсырысты төлеу әрекеттері аяқталды.',
		Sirena2_repeat_needed: 'Төлемге өту мүмкін емес. Бетті жаңартыңыз.',
		Sirena2_unknown_tax_source:
			'Тапсырысты өңдеу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, unknown_tax_source қате кодын хабарлаңыз.',
		Sirena2_invalid_tax_data:
			'Тапсырысты өңдеу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, invalid_tax_data қате кодын хабарлаңыз.',
		Sirena2_ambiguous_taxation_system:
			'Тапсырысты өңдеу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, ambiguous_taxation_system қате кодын хабарлаңыз.',
		Sirena2_unknown_taxation_system:
			'Тапсырысты өңдеу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, unknown_taxation_system қате кодын хабарлаңыз.',
		Sirena2_no_taxation_system:
			'Тапсырысты өңдеу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, no_taxation_system қате кодын хабарлаңыз.',
		Sirena2_shop_commission:
			'Тапсырысты өңдеу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, shop_commission қате кодын хабарлаңыз.',
		Sirena2_shop_status: 'Тапсырыс төленді немесе жойылды.',
		Sirena2_shop_common:
			'Төлем жүйесіне қосылу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, shop_common қате кодын хабарлаңыз.',
		Sirena2_shop_session:
			'Төлем жүйесіне қосылу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, shop_session қате кодын хабарлаңыз.',
		Sirena2_bank_network:
			'Банк уақытша қолжетімді емес. Бетті жаңартып, әрекетті қайталаңыз. Мәселе шешілмесе, техникалық қолдау көрсету қызметіне хабарласыңыз.',
		Sirena2_bank_account: 'Қате карта деректемелері. Деректемелерді тексеріп, әрекетті қайталаңыз.',
		'Sirena2_bank_i-prohibition':
			'Бұл картамен төлеу мүмкін емес. Банкке хабарласыңыз немесе басқа картаны пайдаланыңыз.',
		Sirena2_system_3dsecure:
			'Карта деректемелерін тану мүмкін болмады. Енгізілген деректерді тексеріп, әрекетті қайталаңыз.',
		Sirena2_system_common:
			'Төлем жүйесіне қосылу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, system_common қате кодын хабарлаңыз.',
		Sirena2_3dsecure_failed:
			'Карта деректемелерін тану мүмкін болмады. Енгізілген деректерді тексеріп, әрекетті қайталаңыз.',
		Sirena2_user_timeout: 'Төлеу уақыты аяқталды. Бетті жаңартып, әрекетті қайталаңыз.',
		Sirena2_user_cancel: 'Операция тоқтатылды.',
		Sirena2_user_duplicate:
			'Төлемді өңдеу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, no_taxation_system қате кодын хабарлаңыз.',
		Sirena2_shop_network:
			'Төлем жүйесіне қосылу мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, user_duplicate қате кодын хабарлаңыз.',
		Sirena2_shop_price:
			'Төлем процесін бастау мүмкін болмады. Техникалық қолдау көрсету қызметіне хабарласып, shop_price қате кодын хабарлаңыз.',
		Sirena2_shop_invalid_fop: 'Бұл төлем әдісі қолжетімді емес. Басқа әдісті пайдаланыңыз.',
		Sirena2_shop_wrong_amount:
			'Қате тапсырыс құны. Бетті жаңартыңыз немесе техникалық қолдау көрсету қызметіне хабарласыңыз.',
		Sirena2_bank_funds: 'Шотта қаражат жеткіліксіз. Балансты толтырыңыз немесе басқа картаны пайдаланыңыз.',
		Sirena2_bank_limit:
			'Карта бойынша операциялар шегінен асып кетті. Банкке хабарласыңыз немесе басқа картаны пайдаланыңыз.',
		Sirena2_bank_common:
			'Банк төлемді қабылдамады. Әрекетті қайталаңыз немесе басқа картаны пайдаланыңыз. Мәселе шешілмесе, техникалық қолдау көрсету қызметіне хабарласыңыз.',
		Sirena2_system_in_progress:
			'Төлем өңделуде. Бірнеше минуттан кейін тапсырыс күйін тексеріңіз. Мәселе шешілмесе, техникалық қолдау көрсету қызметіне хабарласыңыз.',
		Sirena2_system_fraud: 'Күдікті операциялардан қорғаныс іске қосылды.'
	},
	PaymentForm: {
		Title_MoneyCarePro: 'Несиеге сатып алу',
		Header_MoneyCarePro: 'Несиеге сатып алу',
		Title_PayLate: 'Бөліп төлеу',
		Header_PayLate: 'Бөліп төлеу',
		Title_Idram: 'Idram арқылы төлеу',
		Header_Idram: 'Idram арқылы төлеу',
		Payment: 'Төлем',
		Total: 'Барлығы',
		'Choose a convenient payment method': 'Ыңғайлы төлем әдісін таңдаңыз',
		'Credit or debit card': 'Картамен онлайн',
		Service: 'Билеттер мен қызметтер',
		Charge: 'Алымдар мен комиссиялар',
		'Pay by credit or debit card': 'Картамен онлайн төлеу',
		'Other methods': 'Басқа төлем әдістері',
		'In the next step you will be taken to a Google Pay page.':
			'Келесі қадамда Google Play төлем бетіне бағытталасыз.',
		'Test payment': 'Сынақ төлем',
		'Edit order': 'Тапсырысты өзгерту',
		Instalment: 'Бөліп төлеу',
		Aeroexpress: 'Аэроэкспресс',
		Airticket: 'Билеттер',
		Baggage: 'Жолжүк',
		Insurance: 'Сақтандыру',
		BusinessLounge: 'Бизнес зал',
		Businesslounge: 'Бизнес зал',
		Vip: 'VIP қызметтер',
		Meals: 'Тамақтану',
		'Please, click «Edit Order» after successful payment in Kaspi.kz APP to open your order.':
			'Kaspi.kz қосымшасында сәтті төлем жасағаннан кейін, «тапсырысты өзгерту» түймесін басу арқылы тапсырысқа оралыңыз.',
		Seats: 'Орындар',
		'Failed to get billing code': 'Төлем кодын алу мүмкін болмады',
		Invoicebox: 'Инвойсбокс',
		FPS: 'Жылдам төлемдер жүйесі',
		SberPay: 'SberPay',
		'Payment code': 'Төлем коды',
		Pay: 'Төлеу',
		'Problems with payment?': 'Төлемге қатысты мәселелер бар ма?',
		'Payment by QIWI': 'QIWI арқылы төлеу',
		'Payment problems hint':
			'Егер карта мәліметтерін енгізуге арналған қалқымалы терезе пайда болмаса, бетті қайта жүктеп көріңіз.',
		'Please, click «Edit Order» after successful payment in QIWI app to open your order.':
			'QIWI қосымшасында сәтті төлем жасағаннан кейін «тапсырысты өңдеу» түймесін басу арқылы тапсырысқа оралыңыз.',
		'Payment by this method is temporarily unavailable, please try refreshing the page or try again later.':
			'Бұл әдіспен төлеу уақытша мүмкін емес, бетті жаңартып көріңіз немесе әрекетті кейінірек қайталаңыз.',
		'The payment with this method is unavailable.': 'Бұл әдіспен төлеу уақытша мүмкін емес.'
	},
	PaymentProvider: {
		PayLate: 'PayLate',
		MoneyCarePro: 'MoneyCarePro'
	},
	PaymentResult: {
		'Payment successfully complete': 'Төлем сәтті аяқталды',
		'View booking': 'Тапсырысқа өту',
		'Payment has failed': 'Төлем сәтсіз аяқталды',
		'Try again': 'Қайталап көру'
	},
	PaymentTimeLimit: {
		'Booking must be completed': 'Тапсырыс рәсімделуі қажет',
		'Booking must be paid': 'Тапсырыс төленуі қажет',
		before: 'дейін',
		'today before': 'бүгін ... дейін',
		'Sorry,': 'Өкінішке орай,',
		'time to complete booking has expired': 'тапсырысты рәсімдеу уақыты аяқталды',
		'Repeat search': 'Іздеуді қайталау',
		'Cancel order': 'Тапсырыстан бас тарту'
	},
	PriceGraph: {
		'Outbound flight': 'Бару рейсін таңдаңыз',
		'Return flight': 'Қайту рейсін таңдаңыз',
		min: 'мин.',
		max: 'макс.',
		'Select month': 'Айды таңдаңыз',
		Select: 'Таңдау',
		from: 'бастап',
		'Approximate prices for 1 person for 1 direction': 'Көрсетілген бағалар бір жаққа 1 адамға арналған',
		'Price for 1 direction': 'Бір жақты бағалар',
		'Show flights': 'Рейстерді көрсету'
	},
	PriceInMiles: {
		miles_1: 'миль',
		miles_2: 'миль',
		miles_3: 'мильдер'
	},
	PriceLock: {
		'Lock this price! We will wait for you': 'Бағаны қатырыңыз! Біз күтетін боламыз',
		'Lock it for 72 hours from just': 'Бар болғаны ... 72 сағатқа бағаны қатыру',
		'per passenger and leg': 'жолаушы үшін',
		'I want to lock the price for this flight': 'Бұл ұшу бағасын қатырғым келеді'
	},
	PromoCode: {
		'Promo code not applied': 'Промокод қолданылмаған',
		reset: 'жою',
		'Do you have a promo code?': 'Сізде промокод бар ма?',
		'Promo code applied': 'Промокод қолданылған',
		'Enter a promo code': 'Промокодты енгізіңіз',
		'Promo code not applied for this flights': 'Бұл ұшу үшін промокод қолданылмаған',
		'Promo code': 'Промокод',
		Required: 'Міндетті өріс',
		'I confirm that I am an employee of Rostech. Otherwise, the Carrier has the right to cancel the ticket.':
			'Ростехтің қызметкері екенімді растаймын. Өзге жағдайда Тасымалдаушы билет күшін жоюға құқылы.',
		'The number of characters must not exceed {{number}}': 'Таңбалар саны {{number}} аспауға тиіс'
	},
	PromoLoader: {
		'One moment please': 'Бір секунд, өтінемін',
		'Discover new horizons': 'Жаңа көкжиектерді ашыңыз',
		'International flights from Kazakhstan': 'Қазақстаннан жүзеге асатын халықаралық рейстер',
		Istanbul: 'Стамбул',
		Tbilisi: 'Тбилиси',
		Moscow: 'Мәскеу',
		Xiang: 'Хубэй',
		'Comfort on board': 'Борттағы жайлылық',
		Meal: 'Тамақтану',
		'Wi-Fi Connect': 'Борттағы Интернет',
		Fleet: 'Біздің флот',
		Seats: 'Орындар',
		'It is safe to fly': 'Ұшу қауіпсіз',
		'2,000 miles giveaway!': 'Сыйға 2000 миль береміз!',
		'Choose your seats when booking': 'Брондау кезінде орындарды таңдаңыз',
		'Save up to 25% when buying extra baggage right away':
			'Брондау кезінде қосымша жолжүкті сатып алу арқылы 25%-ға дейін үнемдеңіз',
		'We want to make sure your travel experience is as fun and smooth as possible also when travelling as a family. All the way from planning your trip to arriving at the airport and enjoying your time in the air, we pay special attention to your comfort.':
			'Сапарыңыздың, әсіресе бүкіл отбасыңызбен саяхаттайтын болсаңыз, мүмкіндігінше жеңіл әрі жағымды болғанын қалаймыз. Біз әрқашан сапарыңызды жоспарлау сәтінен әуежайға келіп, ұшудың өзіне дейін сезінетін жайлылығыңызға ерекше көңіл бөлеміз.',
		'Every Nordwind flight is an opportunity to relax and replenish. On our local flights by Russia and flights to CIS, we serve a diverse selection of food, snacks and beverages, tailored to the time and length of your flight.':
			'Nordwind Airlines рейстерімен саяхаттау кезінде ұсынылған сұрыптамадан тіскебасар мен ыстық тағамды таңдау арқылы мінсіз рационды қалыптастыруыңызға болады',
		'The Nordwind fleet consists of over 30 aircraft. Our fleet is one the most modern in country, and thanks to it can offer you even better travel comfort on our flights.':
			'Nordwind паркінде 30-дан астам ұшақ бар. Біздің парк еліміздегі ең заманауи парктердің бірі болып табылады және осының арқасында біз сізге өз рейстерімізде бұдан да жоғары дәрежелі жайлылықты ұсына аламыз.',
		'Every flight is an opportunity to relax and replenish. On our local flights by Russia and flights to CIS, we serve a diverse selection of food, snacks and beverages, tailored to the time and length of your flight.':
			'Бізбен саяхаттау кезінде ұсынылған сұрыптамадан тіскебасар мен ыстық тағамды таңдау арқылы мінсіз рационды қалыптастыруыңызға болады',
		'The fleet consists of over 30 aircraft. Our fleet is one the most modern in country, and thanks to it can offer you even better travel comfort on our flights.':
			'Біздің паркте 30-дан астам ұшақ бар. Бұл еліміздегі ең заманауи парктердің бірі болып табылады және осының арқасында біз сізге өз рейстерімізде бұдан да жоғары дәрежелі жайлылықты ұсына аламыз.',
		'Flying is not a reason to refuse to communicate with family and colleagues. Wi-Fi internet on board is a unique portal to the world of entertainment and information in flight.':
			'Ұшу – бұл отбасымен және әріптестерімен қарым-қатынастан бас тартуға себеп емес. Біздің ұшақтың бортындағы сымсыз интернет – бұл ұшу кезіндегі ойын-сауық пен ақпарат әлеміне бірегей портал.',
		'Want to sit together or love the window seat? Do not leave the choice of place to chance.':
			'Бірге отырғыңыз келе ме немесе терезе жанындағы орындарды ұнатасыз ба? Орын таңдауды кездейсоқ қалдырмаңыз.',
		'From locking middle seats to completely disinfecting our aircraft, we do our best to keep you safe.':
			'Ортаңғы орындықтарды құлыптаудан және қорғаныс бетперделерін қолдануды талап етуден бастап, ұшақтарымыздағы әрбір бұрышты дезинфекциялауға дейін біз сізді қауіпсіз жерде және сау ұстау үшін бар күшімізді саламыз',
		'To thank you for your loyalty and support, we grant our club members 2,000 miles!':
			'Сіздің адалдығыңыз бен қолдауыңыз үшін алғыс білдіру үшін біз клуб мүшелеріне 2000 миль сыйлаймыз!',
		'Don’t let chance affect your comfort and convenience.': 'Жайлылық пен ыңғайлылықты кездейсоқ қалдырмаңыз.'
	},
	PromoMessage: {
		'Buy now - pay later': 'Қазір ұшыңыз - кейінірек төлеңіз! КЭШБЕК 15%',
		'Learn more': 'Көбірек білу',
		'You can buy any ticket with credit for 12 months, without an initial payment, with a grace period of 30 days.':
			'Билет бағасын бекітудің ыңғайлы жолы. Билеттер ресімделгеннен кейін бірден поштаңызда болады. Бастапқы төлем 0 рубль.',
		'Only Citizens of the Republic of Uzbekistan and Tajikistan are allowed on the flight':
			'Рейске тек Өзбекстан және Тәжікстан Республикасының азаматтары ғана жіберіледі'
	},
	QuickSearchForm: {
		'Modify search': 'Іздеуді өзгерту',
		Adult_0: 'Ересек',
		Adult_1: 'Ересек',
		Adult_2: 'Ересек',
		Child_0: 'Бала',
		Child_1: 'Бала',
		Child_2: 'Балалар',
		Infant_0: 'Нәресте',
		Infant_1: 'Нәресте',
		Infant_3: 'Нәресте',
		ADT_0: 'ересек',
		ADT_1: 'ересек',
		ADT_2: 'ересек',
		passenger_0: 'жолаушы',
		passenger_1: 'жолаушы',
		passenger_2: 'жолаушылар',
		МЛА_0: 'Жолаушы (жастар)',
		МЛА_1: 'Жолаушы (жастар)',
		МЛА_2: 'Жолаушылар (жастар)',
		SCM_0: 'Жолаушы (зейнеткерлер)',
		SCM_1: 'Жолаушы (зейнеткерлер)',
		SCM_2: 'Жолаушылар (зейнеткерлер)',
		SCF_0: 'Жолаушы (зейнеткерлер)',
		SCF_1: 'Жолаушы (зейнеткерлер)',
		SCF_2: 'Жолаушылар (зейнеткерлер)',
		PDA_0: 'Жасөспірім',
		PDA_1: 'Жасөспірім',
		PDA_2: 'Жасөспірімдер',
		YTH_0: 'Жастар',
		YTH_1: 'Жастар',
		YTH_2: 'Жастар',
		SRC_0: 'Зейнеткер',
		SRC_1: 'Зейнеткер',
		SRC_2: 'Зейнеткерлер',
		РВТ_0: 'Орны бар нәресте'
	},
	RecaptchaPage: {
		'You\'re not a bot, are you?': 'Сіз бот емессіз бе?'
	},
	RecommendedBadge: {
		'Best choice': 'Үздік таңдау'
	},
	Refund: {
		'I agree with the': 'Мен',
		'Terms of Service': 'қызмет көрсету ережелерімен',
		And: 'және',
		'Privacy Policy': 'құпиялылық саясатымен келісемін',
		New: 'Жаңа өтінім',
		AllDataSaved: 'Деректер сақталды',
		Adopted: 'Өтінім қабылданды',
		Calculated: 'Қайтару сомасы есептелді',
		ClaimReceived: 'Өтінім жіберілді',
		AwaitingPayment: 'Қаражатты қайтару күтілуде',
		TimelimitExpired: 'Растау уақыты аяқталды',
		Finished: 'Аяқталды',
		Cancelled: 'Бас тартылды',
		Rejected: 'Қабылданбады',
		NeedConfirm: 'Растау күтілуде',
		InProcess: 'Орындалуда',
		'Add new request': 'Жаңа өтінім жасау',
		Refused: 'Пайдаланушы қабылдамады',
		FlightCancellationOrDelay: 'Билетте көрсетілген рейсті тоқтату немесе кешіктіру;',
		Rerouting: 'Бағыттың өзгеруі (қолайсыз ауа-райы жағдайлары мен форс-мажорларды есепке алмағанда);',
		FlightOperationOutOfSchedule: 'Кестеден тыс ұшуларды орындау;',
		SeatUnavailability: 'Жолаушыға билетте көрсетілген рейске және күнге орын болмауы;',
		EnduringSecurityScreening:
			'Егер жолаушы ұзақ тексеру/тексеру салдарынан ұшақ бортына көтеріле алмаса, мұндай тексеру/тексеру кезінде ешқандай тыйым салынған заттектер немесе заттар табылмаған жағдайда;',
		FailedEnsureConnectionOfFlights:
			'Егер тасымалдаушы түйісу рейстері біржолғы болып табылған жағдайда рейстердің түйісуін қамтамасыз етпесе;',
		Illness:
			'Егер мұндай ауру тиісті медициналық құжаттармен расталса немесе жолаушы немесе оның отбасы мүшесі қайтыс болған жағдайда, егер қайтыс болғаны тиісті медициналық құжаттармен расталса, бұл туралы билетте көрсетілген тіркеу уақыты аяқталғанға дейін хабарланған жағдайда, жолаушымен бірге саяхаттайтын оның отбасы мүшесі-жолаушының ауруы; мұндай медициналық құжаттарға қойылатын талаптар туралы толығырақ ақпарат осында келтірілген;',
		FailedToProvideServices: 'Егер тасымалдаушы жолаушыға билетте көрсетілген класқа сәйкес қызмет көрсетпесе;',
		FailedToIssueTicketAppropriately:
			'Егер тасымалдаушы немесе оның уәкілетті агенті билетті тиісті түрде жазып бермесе;',
		OtherCases: 'Тасымалдаушының кінәсінен жолаушы тасымалдау қызметімен қамтамасыз етілмеген басқа жағдайларда;',
		MedicalCertificate: 'Медициналық анықтама',
		Request: 'Өтінім',
		Create: 'Жасалған',
		'Your comments': 'Сіздің пікірлеріңіз',
		'Refund amount': 'Қайтаруға',
		'Ticket price': 'Тапсырыс құны',
		'FareExchange penalty': 'Айырбастағаны үшін айыппұл',
		Continue: 'Жалғастыру',
		Back: 'Артқа',
		'Select passengers': 'Жолаушыларды таңдаңыз',
		'Choose the reason for refund': 'Қайтару себебін таңдаңыз',
		'Involuntary refund': 'Еріксіз қайтару',
		'Voluntary refund': 'Ерікті түрде қайтару',
		'my plans have changed': 'менің жоспарларым өзгерді',
		'Attach the required files': 'Қажетті файлдарды тіркеңіз',
		'File format: jpg, pdf. File size: no more than 5MB':
			'Файл пішімі: jpg, png, pdf, doc, docx. Файл өлшемі: 5 МБ-тан аспайды',
		'Your name': 'Сіздің атыңыз',
		'Your email': 'Сіздің эл. поштаңыз',
		'Your phone': 'Сіздің телефоныңыз',
		'I agree to the': 'Мен',
		'Terms of Service and Privacy Policy': 'қызмет көрсету шарттарымен және құпиялылық саясатымен келісемін',
		'Create request': 'Өтінім жасау',
		'Only letters': 'Тек әріптер',
		Required: 'Міндетті өріс',
		'Wrong email': 'Дұрыс емес эл. пошта',
		'Wrong phone': 'Дұрыс емес телефон нөмірі',
		For: 'үшін',
		Files: 'Файлдар',
		'Refund ticket': 'Билетті қайтару',
		'Refund restrictions': 'Қайтару кезіндегі шектеулер',
		Note: 'Назар аударыңыз',
		'The possibility and amount of refund will be calculated by the operator after sending the application. The answer will be sent to your E-mail and is also available on the order page.':
			'Мүмкіндігі мен қайтару сомасын оператор өтінімді жібергеннен кейін есептейді. Жауап электрондық поштаңызға жіберіледі және тапсырыс бетінде де қолжетімді болады.',
		'After submitting the request, the seats you have selected will be canceled.':
			'Сұрау жіберілгеннен кейін сіз таңдаған орындар жойылады.',
		'The money will be returned to the card used to pay for the ticket within 15 days':
			'Ақша билетті төлеу үшін пайдаланылған картаға 15 күн ішінде қайтарылады.',
		Reject: 'Бас тарту',
		Confirm: 'Растау',
		'The request is accepted for processing. The answer will be sent to your email and also available on the order page.':
			'Сіздің сұрауыңыз қабылданды және өңделуде. Жауап электрондық поштаға жіберіледі және тапсырыс бетінде де қолжетімді болады.',
		'The request was deleted. Want to create a new request?': 'Өтінім жойылады. Жаңа өтінім жасағыңыз келе ме?',
		'Successful refund. Confirmation and detalization have been sent to your e-mail':
			'Сәтті қайтару. Толық ақпарат сіздің эл. поштаңызға жіберіледі',
		Ok: 'OK',
		Yes: 'Иә',
		No: 'Жоқ',
		'Request for refund': 'Қайтару туралы сұрау',
		'Successfully refund': 'Сәтті қайтару',
		'Delete request': 'Өтінімді жою',
		FlightNumberChange: 'Рейс нөмірін өзгерту',
		FlightRetimed: 'Рейс жаңартылды',
		FlightCancelled: 'Рейс тоқтатылды',
		PermanentWithdrawalOfService: 'Қызмет көрсетуді тұрақты тоқтату',
		LaborDispute: 'Еңбек дауы',
		Bereavement: 'Ауыр қаза',
		UnableToObtainNecessaryDocumentation: 'Қажетті құжаттаманы алу мүмкін емес',
		Strike: 'Ереуіл',
		Weather: 'Ауа-райы жағдайлары',
		NaturalDisaster: 'Табиғи апат',
		UnacceptableReaccommodation: 'Орынсыз орналастыру',
		Refund_Passengers: 'Жалғастыру',
		Refund_Reason: 'Жалғастыру',
		Refund_CreateTicket: 'Жалғастыру',
		'terms of tariff': 'тариф шарттарымен',
		'Back to order': 'Тапсырысқа оралу',
		'To make an exchange please contact a customer support service':
			'Қайтару үшін қолдау көрсету орталығына хабарласу қажет',
		'Oops...': 'Ой...',
		'View related booking': 'Байланысты тапсырысты ашу',
		'It is not possible to refund a ticket that has been checked-in for a flight':
			'Рейске тіркеу жүргізілген билетті қайтару мүмкін емес',
		'If you wish to make a refund, please cancel your flight check-in.':
			'Егер қайтаруды қаласаңыз, рейске тіркелуден алдын ала бас тартыңыз.',
		'You can do it yourself by going to <a href=\'{{link}}\' target=\'_blank\'>Online Registration section</a>.':
			'Мұны <a href=\'{{link}}\' target=\'_blank\'>Онлайн тіркелу</a> бөліміне өту арқылы өз бетінше жасауға болады.',
		'It is not possible to refund a used ticket': 'Пайдаланылған билетті қайтару мүмкін емес',
		'The ticket has been flown on, you cannot return a used ticket.':
			'Билет бойынша ұшу жүзеге асырылды, пайдаланылған билетті қайтаруға болмайды.'
	},
	RegisteredPassenger: {
		Economy: 'Эконом',
		Business: 'Бизнес',
		First: 'Бірінші',
		'Download boarding pass': 'Отырғызу талонын жүктеп алу',
		Download: 'Жүктеп алу',
		CarryOn: 'Қол жүк',
		CheckedBaggage: 'Жолжүк',
		SportingEquipment: 'Спорт жабдығы',
		'Select flight for download': 'Ұшуды таңдаңыз',
		'Select flight': 'Ұшуды таңдаңыз',
		Seats: 'Орындар',
		Meal: 'Тамақтану',
		'Cancel check-in': 'Тіркеуден бас тарту',
		'Retry check-in': 'Тіркеуді қайталау',
		Yes: 'Иә',
		No: 'Жоқ',
		'You are going to cancel online check-in for passenger {{passenger}}. Are you sure about this?':
			'{{passenger}} жолаушысы үшін онлайн тіркелуден бас тартқыңыз келетініне сенімдісіз бе?',
		'Send to email': 'Эл. поштаға жіберу',
		Send: 'Жіберу',
		'Registration available only at airport': 'Тіркеу тек әуежайда қолжетімді',
		'You must receive the boarding pass at the airport on the registration desk.':
			'Отырғызу талонын әуежайдағы тіркеу үстелшесінде алу қажет.',
		'Send all documents to email': 'Барлық құжаттарды поштаға жіберу',
		Cancel: 'Бас тарту',
		'Required field': 'Міндетті өріс',
		'Please enter a valid email': 'Жарамды электрондық пошта мекенжайын енгізіңіз',
		Email: 'Эл. пошта мекенжайы',
		'Please notice that online check-in will also be cancelled for the following passengers':
			'Сондай-ақ келесі жолаушылар үшін тіркеу тоқтатылады:',
		'Select segments to cancel': 'Бас тарту үшін рейстерді таңдаңыз'
	},
	ResendTicketsForm: {
		Email: 'Эл. пошта мекенжайы',
		Send: 'Жіберу',
		Required: 'Толтыру қажет',
		'Resend booking': 'Билеттерді жіберу',
		'Failed to send tickets to the specified mail, try again later':
			'Көрсетілген поштаға билеттерді жіберу мүмкін болмады, әрекетті қайталаңыз',
		'Please enter a valid email': 'Енгізілген эл. пошта мекенжайын тексеріңіз'
	},
	Results: {
		'Select flight': 'Рейсті таңдаңыз',
		'Select flight to on': '{{city}} {{date}} рейсін таңдаңыз',
		'Monthly price': 'Бір айға',
		'Weekly price': 'Бір аптаға',
		Back: 'Артқа',
		Sorting: 'Сұрыптау',
		Filters: 'Сүзгілер',
		'Sort by': 'Сұрыптау',
		Arrival: 'Ұшып келу уақыты',
		Departure: 'Ұшып шығу',
		'Best flight': 'Үздік ұшу',
		Price: 'Бағасы',
		'Flight time': 'Жол жүру уақыты',
		Returning: 'Қайту',
		Departing: 'Бару',
		'You\'ve chosen': 'Таңдалған ұшулар',
		'Depart on': 'Ұшып шығу',
		'Departure time': 'Ұшып шығу уақыты',
		'save up to': 'үнемдеңіз',
		'Sold out': 'Билеттер сатылды',
		'Show flights': 'Нұсқаларды көрсету',
		'Unfortunately, all seats on selected flight are already sold out.':
			'Өкінішке орай, сіз таңдаған рейске барлық билеттер сатылып кеткен.',
		'We can offer you another flights for the same dates.': 'Біз сізге сол күнге басқа рейстерді ұсына аламыз.',
		'Other dates': 'Басқа күндер',
		'Total price': 'Барлығы',
		'Want to continue booking on your computer?': 'Компьютеріңізде брондауды жалғастырғыңыз келе ме?',
		'Continue booking': 'Брондауды жалғастыру',
		'Only direct flights': 'Тек тікелей рейстер',
		'Only business class': 'Тек бизнес класс',
		Ok: 'OK',
		'Show price diagram': 'Бағалар кестесі',
		'Redeem miles': 'Мильдерді пайдалану',
		Card: 'Карта',
		'Change card': 'Картаны ауыстыру',
		'Pay by money': 'Ақшамен төлеу',
		'You sure?': 'Сенімдісіз бе?',
		'Delete card from your account?': 'Картаны тіркелгіңізден жою қажет пе?',
		No: 'Жоқ',
		Yes: 'Иә',
		Nonstop: 'Ауысып отыру жоқ',
		'Business Class': 'Бизнес класс',
		Attention: 'Назар аударыңыз',
		'You are buying a separate ticket for a child. For children under 12 years old unaccompanied traveling is not allowed. On the passenger data page select who will fly with the child: enter the ticket number and the name of the accompanying person over 18 years old. Please note: both passengers must be of the same class of service.':
			'Сіз балаңызға бөлек әуе билетін сатып аласыз. 12 жасқа толмаған балалар ересектердің алып жүруінсіз саяхаттай алмайды. Жолаушы деректерін енгізу бетінде баламен кім ұшатынын көрсетіңіз: 18 жастан асқан алып жүруші әуе билетінің нөмірін және аты-жөнін енгізіңіз. Назар аударыңыз: екі жолаушының да қызмет көрсету класы бірдей болуға тиіс.',
		'If you still have questions, please contact the Contact Center.':
			'Сұрақтарыңыз болса, Байланыс орталығына хабарласыңыз.'
	},
	RetrieveBooking: {
		'Booking ID': 'Билет нөмірі, тапсырыс нөмірі немесе брондау коды',
		'Security code': 'Кіру коды немесе жолаушының тегі',
		'Retrieve booking': 'Брондауға қолжетімділік',
		Open: 'Іздеу',
		'Enter ticket number': 'Билет нөмірін енгізіңіз',
		'Enter passenger last name': 'Жолаушының тегін енгізіңіз',
		'Enter your book code or ticket number': 'Бронь кодын немесе билет нөмірін енгізіңіз',
		'Incorrect value': 'Тегі дұрыс емес',
		'Ticket number': 'Билет нөмірі',
		'Required field': 'Міндетті өріс',
		'Please enter ticket number for passenger you would like to check-in':
			'Рейске тіркеу қажет жолаушының билет нөмірін енгізіңіз',
		'Order not found': 'Тапсырыс табылмады',
		'Passenger not found': 'Жолаушы табылмады',
		'You can find security code in your booking confirmation email':
			'Кіру кодын брондауды растау туралы электрондық хатында табуға болады',
		'The order is being paid at the moment, please try again later':
			'Қазіргі уақытта тапсырыс үшін төлем жасалуда, әрекетті кейінірек қайталаңыз',
		'Enter your ticket number': 'Билет нөмірін енгізіңіз',
		'Booking not found. Please, check the information entered or use your e-ticket number for identification':
			'Брондау табылмады. Енгізілген ақпаратты тексеріңіз немесе сәйкестендіру үшін электрондық билет нөмірін пайдаланыңыз',
		'Online check-in is not available. Check-in only at the airport':
			'Онлайн тіркелу қолжетімді емес. Тек әуежайда тіркелуге болады'
	},
	Schedule: {
		'Where are you flying from': 'Қайдан ұшасыз',
		'Where are you flying to': 'Қайда ұшасыз',
		'Is operated by': 'Рейс орындайды',
		'We did not find flights to the selected cities': 'Таңдалған қалаларға рейстер табылмады',
		'Please select another city or change your search. If you would like to purchase a ticket for a specific city, please contact customer service.':
			'Басқа қаланы таңдаңыз немесе іздеуді өзгертіңіз. Егер сіз нақты қалаға билет сатып алғыңыз келсе, тұтынушыларға қолдау көрсету қызметіне хабарласыңыз.'
	},
	ScheduleForm: {
		Schedule: 'Кесте',
		From: 'Қайдан',
		To: 'Қайда',
		'From, enter city or country': 'Қайдан, қаланы немесе елді енгізіңіз',
		'To, enter city or country': 'Қайда, қаланы немесе елді енгізіңіз',
		'Please select {{type}} airport': '{{type}} әуежайын таңдаңыз',
		'Please select different airports': 'Әртүрлі әуежайларды таңдаңыз',
		arrival: 'ұшып келу',
		departure: 'ұшып шығу'
	},
	SearchForm: {
		'Enter promo code': 'Промокодты енгізу',
		'Redeem miles': 'Мильдерді жұмсау',
		'Set simple route': 'Қарапайым бағытқа',
		'Set multi city route': 'Күрделі бағыт құрастыру',
		From: 'Қайдан',
		To: 'Қайда',
		'Please select {{type}} airport': '{{type}} әуежайын таңдаңыз',
		'Please select different airports': 'Әртүрлі әуежайларды таңдаңыз',
		Search: 'Іздеу',
		'Please select departure date': 'Ұшып шығу күнін таңдаңыз',
		Outbound: 'Бару',
		Return: 'Қайту',
		Dates: 'Ұшып шығу күні',
		arrival: 'ұшып келу',
		departure: 'ұшып шығу',
		'From, enter city or country': 'Қала немесе ел',
		'To, enter city or country': 'Қала немесе ел',
		passenger_0: 'жолаушы',
		passenger_1: 'жолаушы',
		passenger_2: 'жолаушылар',
		Passengers: 'Жолаушылар',
		'Other categories': 'Басқа санаттар',
		Clear: 'Тазалау',
		Done: 'Дайын',
		'Enter name or code of category': 'Атауды немесе санат кодын енгізіңіз',
		'Pay by miles': 'Мильдерді пайдаланғым келеді',
		'Please select passengers': 'Жолаушыларды таңдаңыз',
		'Offer hotels': 'Қонақ үйлерді ұсыну',
		'Departure airport or city': 'Ұшып шығу қаласы',
		'Arrival airport or city': 'Ұшып келу қаласы'
	},
	SearchFormDatepicker: {
		Oops: 'Ой',
		'Something went wrong, please check your internet connection or come back later':
			'Бірдеңе дұрыс болмады, интернет қосылымын тексеріңіз немесе әрекетті кейінірек қайталаңыз',
		Ok: 'OK',
		'Without back date': 'Қайту билеті қажет емес',
		Clear: 'Қалпына келтіру',
		Done: 'Дайын',
		'One way': 'Дайын',
		'Price matrix': 'Бағаларды салыстыру',
		Calendar: 'Күнтізбе',
		'Price graph': 'Бір айға арналған бағалар',
		Outbound: 'Бару',
		Return: 'Қайту',
		'Approximate prices for 1 person for 1 direction': 'Көрсетілген бағалар бір жаққа 1 адамға арналған'
	},
	SeatMap: {
		'Less than 24 hours left before the flight': 'Рейстің ұшуына 24 сағаттан аз уақыт қалды',
		'You can select seats using the online registration service after issuing tickets':
			'Билеттерді рәсімдегеннен кейін онлайн тіркелу қызметін пайдалана отырып, орын таңдауға өтуге болады',
		Restriction_ElderlyPerson: '65 жастан асқан жолаушылар',
		Restriction_Unaccompanied: 'Алып жүрілмеген балалар',
		Restriction_SeriouslyIllPeople: 'Мүмкіндігі шектеулі тұлғалар',
		Restriction_DoNotSpeakTheLanguage: 'Экипаж тілінде сөйлемейтін жолаушылар',
		Restriction_EscortedChildren: 'Алып жүрілмеген балалар',
		Restriction_Infant: 'Нәрестелері бар жолаушылар',
		Restriction_NeedOxygenEquipment: 'Арнайы оттек жабдығына мұқтаж жолаушылар',
		Restriction_PassengersOnStretchers: 'Қозғалысы шектеулі жолаушылар мен мүмкіндігі шектеулі тұлғалар',
		Restriction_PassengersUnder18: '18 жасқа толмаған тұлғалар',
		Restriction_PregnantWomen: 'Жүкті әйелдер',
		Restriction_RequiringAccompany: 'Алып жүруге мұқтаж жолаушылар',
		Restriction_VisuallyOrHearingImpaired: 'Көру немесе есту қабілеті бұзылған жолаушылар',
		Restriction_WithAnimals: 'Салонда жануарлары бар жолаушылар',
		'This seat is forbidden for': 'Бұл орынды ... таңдауға тыйым салынған',
		select: 'таңдау',
		'not available': 'қолжетімді емес',
		'Unfortunately, seat selection on this flight is not available.':
			'Өкінішке орай, бұл ұшуға орын таңдау мүмкін емес.',
		'Next flight': 'Келесі ұшу',
		'Reserved seat': 'Бос емес орын',
		'90% on the left side': 'күн сол жақта болады',
		'90% on the right side': 'күн оң жақта болады',
		'Business class': 'Бизнес класс',
		'Economy class': 'Эконом класс',
		'First class': 'Бірінші класс',
		Business: 'Бизнес класс',
		Economy: 'Эконом класс',
		First: 'Бірінші класс',
		Exit: 'Шығу',
		seat_0: '{{count}} орын',
		seat_1: '{{count}} орын',
		seat_2: '{{count}} орын',
		Seats: 'Орындар',
		Adult: 'Ересек',
		Child: 'Бала',
		Infant: 'Нәресте',
		'Infant with seat': 'Орны бар нәресте',
		Free: 'Тегін',
		'MAIN DECK': 'БАСТЫ ПАЛУБА',
		'You can choose your preferred seats.': 'Ең ыңғайлы орындарды таңдаңыз.',
		'UPPER DECK': 'ҮСТІҢГІ ПАЛУБА',
		'Seat details': 'Орындар туралы ақпарат',
		Select: 'Таңдау',
		'Select seat': 'Орынды таңдау',
		'Select your seats': 'Орынды таңдаңыз',
		'Select passenger': 'Жолаушыны таңдаңыз',
		Cancel: 'Бас тарту',
		'Take this seat': 'Орынды таңдау',
		'Change seat': 'Орынды ауыстыру',
		Recommend: 'Ұсынамыз',
		'Fly together!': 'Бірге ұшыңыз!',
		'Show recommended seats': 'Ұсынылатын орындар',
		From: 'Бастап',
		Total: 'Барлығы',
		'Choose your seat': 'Орындарды таңдаңыз',
		'Choose myself': 'Өзіңіз таңдаңыз',
		Confirm: 'Растау',
		'Recommended seats': 'Ұсынамыз',
		Comfort: 'Ыңғайлы орын',
		Preferred: 'Таңдаулы орын',
		Standart: 'Стандартты орын',
		Clear: 'Тазалау',
		'Clear all': 'Барлығын тазалау',
		'Passenger, {{type}}': 'Жолаушы, {{type}}',
		'Next Flight': 'Келесі ұшу',
		Back: 'Артқа',
		from: 'бастап',
		Done: 'Дайын',
		'The top ones get the top seats. Be on top!':
			'Үздік орындарды бірінші болып үлгергендер алады. \n\n Бірінші болыңыз!',
		'If you don\'t select a seat, we\'ll automatically allocate your seats when you check-in.':
			'Орынды қазір таңдауды ұсынамыз, үздік орындарды бірінші болып үлгергендер алады!',
		'Pay attention!': 'Назар аударыңыз!',
		'The airline reserves the right to replace the aircraft.':
			'Әуе компаниясы әуе кемесін ауыстыру құқығын өзіне қалдырады.',
		'In the event of an aircraft replacement, passengers who have paid for the “seat selection” service will be provided with seats on the plane that are similar in price and comfort, while maintaining the following parameters':
			'Әуе кемесі ауыстырылған жағдайда, «Орын таңдау» қызметіне ақы төлеген жолаушыларға бағасы мен жайлылығы жағынан келесі параметрлерді сақтай отырып, ұшақта ұқсас орындар берілетін болады',
		'- Cost of services;': '— Қызмет құны;',
		'- Location of the place relative to the window / aisle;': '— Терезеге/өткелге қатысты орынның орналасуы;',
		'- Joint seating, if one was originally selected;': '— Егер бастапқыда таңдалған болса, бірлесіп отырғызу;',
		'- Placement in the front row of the cabin, if one was originally selected.':
			'— Бастапқыда таңдалған болса, салонның бірінші қатарына орналастыру.',
		'Terms & conditions': 'Қызмет туралы толығырақ',
		Continue: 'Жалғастыру',
		Note: 'Маңызды',
		SeatMap_Comfort: 'Ыңғайлы',
		SeatMap_Preferred: 'Таңдаулы',
		SeatMap_Standart: 'Стандартты',
		SeatMap_Standard: 'Стандартты',
		'Selected seat is not available': 'Таңдалған орын қолжетімді емес',
		'The passenger can select a suitable seat marked for passengers with pets on the map. The airline has the right to transfer a passenger with an animal.':
			'Жолаушы картадан жануарлары бар жолаушыларға арналған белгісі бар қолайлы креслоны таңдай алады. Әуе компаниясы жануары бар жолаушыны басқа орынға отырғызуға құқылы.',
		'This seat is allowed for': 'Бұл орын ... үшін таңдауға рұқсат етілген',
		Permissions_WithAnimals: 'Жануарлары бар жолаушылар',
		'Free seat': 'Тегін',
		'Free seats': 'Тегін орындар',
		'Information for the place': 'Орын туралы ақпарат',
		'Chair back does not recline': 'Креслоның арқасы еңкейтіледі',
		'Double seat': 'Қос орын',
		'An extra seat can also be booked for the safe transport of valuable and fragile items such as antiques, artifacts, family heirlooms or oversized musical instruments.':
			'Сондай-ақ, антиквариат, артефактілер, отбасылық жәдігерлер немесе ірі көлемді музыкалық аспаптар сияқты құнды және сынғыш заттарды қауіпсіз тасымалдау үшін қосымша орынды брондауға болады.',
		'When choosing the «Double Seat» service, the seats previously added by the passenger will be deleted':
			'«Қос орын» қызметін таңдау кезінде жолаушының бұрын қосқан орындары жойылады',
		'When you select this service, it will be automatically applied to all flights of your route':
			'Бұл қызметті таңдау кезінде ол бағытыңыздағы барлық ұшуларға автоматты түрде қолданылады',
		'When the «Double Seat» service is disabled, the seats added by the passenger earlier will be deleted':
			'«Қос орын» қызметі өшірілген кезде жолаушының бұрын қосқан орындары жойылады',
		'Seat selection': 'Орын таңдау',
		'Children under 2 years of age fly in the same seat with an adult':
			'2 жасқа дейінгі балалар ересек адаммен бір орындықта ұшады',
		'Window seat': 'Терезе жанындағы орын',
		'Seat with no window': 'Терезесі жоқ орын',
		'The service applies to all flights': 'Қызмет барлық ұшуларға қолданылады',
		'Selected seats will be deleted': 'Таңдалған орындар жойылады',
		'Seat next to the partition': 'Арақабырғаның жанындағы орын',
		'Comfort seat': 'Ыңғайлы орын'
	},
	SecureAccess: {
		'Enter your access confirmation number. For security reasons, it was sent to the email you provided when creating the order.':
			'Тапсырысқа қол жеткізуді растау нөмірін енгізіңіз. Қауіпсіздік мақсатында ол сіз тапсырысты жасау кезінде көрсеткен поштаға жіберілді.',
		'Ticket / order number from e-mail': 'Хаттағы билет немесе тапсырыс нөмірі',
		'Add booking': 'Брондауды қосу',
		Continue: 'Жалғастыру',
		'The entered code does not match the code from the email': 'Енгізілген код хаттағы кодпен сәйкес келмейді'
	},
	Segment: {
		Departure: 'Ұшып шығу',
		Flight: 'Рейс нөмірі',
		Terminal: 'Терминал',
		Gate: 'Қонуға шығу',
		Boarding: 'Отырғызу',
		'Fare rules': 'Тариф ережелері',
		'Airport check-in': 'Әуежайда тіркелу',
		'Baggage info': 'Жолжүк туралы ақпарат',
		Economy: 'Эконом',
		Business: 'Бизнес'
	},
	SelectSegment: {
		Confirm: 'Растау',
		'Check-in for flights': 'Рейстерге тіркелу',
		Flight: 'Рейс',
		Select: 'Таңдау',
		GetTalon: 'Тіркелу өтті. Отырғызу талонын алу',
		GoToCheckin: 'Тіркелу ашық. Тіркеуге өту'
	},
	SelectedPassenger: {
		Birthday: 'Туған күні',
		Gender: 'Жынысы',
		Male: 'Ерлер',
		Female: 'Әйелдер',
		Citizenship: 'Азаматтығы',
		Passport: 'Төлқұжат',
		MilitaryIDCard: 'Әскери билет',
		DocOfPassportLusing: 'Уақытша жеке куәлік',
		DiplomaticPassport: 'Дипломатиялық төлқұжат',
		InternationalPassportNotRU: 'Шетелдік төлқұжат',
		InternationalPassportRU: 'Шетелдік төлқұжат',
		InternationalPassport: 'Шетелдік төлқұжат',
		NationalPassport: 'Ұлттық төлқұжат',
		SeamanDocument: 'Теңізшінің төлқұжаты',
		SeniorDocument: 'Ұлттық төлқұжат',
		BirthRegDocument: 'Туу туралы куәлік',
		CertificateOfConvictedVacation: 'Жеке куәлік',
		ResidencePermit: 'Тұруға ықтиярхат',
		Ticket: 'Билет нөмірі',
		'Add frequent flyer number for': '... үшін бейілділік картасының нөмірін қосу',
		Add: 'Қосу',
		'Frequent Flyer Number': 'Бейілділік картасының нөмірі',
		'Add frequent flyer': 'Бейілділік картасын қосу',
		'Frequent flyer': 'Бейілділік картасы'
	},
	Service: {
		from: 'бастап',
		Total: 'Барлығы',
		Close: 'Жабу',
		free: 'Тегін',
		Done: 'Дайын',
		Clear: 'Тазалау'
	},
	ServiceRecommendation: {
		'To save your time, we have selected for you the best available seats on the plane.':
			'Уақытты үнемдеу үшін ұшақтағы ең ыңғайлы бос орындарды таңдадық.',
		'Seats recommendation': 'Ұсынылатын орындар',
		Change: 'Өзіңіз таңдаңыз',
		Confirm: 'Растау',
		Total: 'Барлығы',
		Flight: 'Рейс',
		Seats: 'Орындар',
		Price: 'Бағасы',
		FREE: 'Тегін',
		Details: 'Толық мәліметтер',
		Allergens: 'Аллергендер',
		'OK, thank you': 'Түсінікті, рақмет',
		'We offer you this meal': 'Ұсынылатын тағам беріледі',
		'for FREE': 'ТЕГІН',
		'on all flight directions': 'барлық ұшу бағыттарында',
		'on flight directions': 'бағыттарда',
		'for all passengers': 'барлық жолаушылар үшін',
		'for passengers': 'жолаушылар үшін'
	},
	ServiceWithSegments: {
		'Next flight': 'Келесі рейс'
	},
	SocialAuth: {
		'Social networks accounts': 'Әлеуметтік желілердегі тіркелгілер',
		'Quick login to your account': 'Тіркелгіңізге жылдам кіру',
		'Connect another social media account': 'Тіркелгіні басқа әлеуметтік желіге қосыңыз'
	},
	Stepbar: {
		Flights: 'Ұшулар',
		Seats: 'Орындар',
		Baggage: 'Жолжүк',
		Insurance: 'Сақтандыру',
		Meal: 'Тамақтану',
		Passengers: 'Жолаушылар',
		Extras: 'Қызметтер',
		Payment: 'Төлем',
		Order: 'Тапсырыс',
		'You can {{payload}}': '{{payload}} болады',
		'add services': 'тапсырысқа қызметтерді қосу',
		'change dates': 'ұшып шығу күнін өзгерту'
	},
	Subscriptions: {
		'You have a subscription': 'Сізде жазылым бар',
		'There are users in the order who are not covered by your subscription. The price of their tickets is considered without discount.':
			'Тапсырыста жазылымға кірмейтін пайдаланушылар бар. Мұндай жолаушыларға құны жеңілдіксіз қарастырылады',
		'Members without Subscription': 'Жазылымы жоқ жолаушылар',
		Passenger: 'Жолаушы',
		Without: 'Жазылымы жоқ',
		With: 'Жазылымы бар',
		'Continue, I agree with this price': 'Жалғастыру, бағамен келісемін',
		'Add passengers to subscription': 'Жазылымға жолаушыларды қосу',
		'Reselect services and seats': 'Қызметтер мен орындарды қайта таңдау',
		'Do you have regular flights?': 'Жиі ұшасыз ба?',
		'Cut costs with a subscription': 'Жазылым шығындарды қысқартады',
		'View Offers': 'Ұсыныстарды қарау',
		'Seat selection and other subscription services at a reasonable price':
			'Орынды таңдау және тиімді бағамен жазылымы бар басқа қызметтер',
		'View options': 'Нұсқаларды қарау',
		'Subscription member': 'Жазылымға кіреді',
		'Discounts apply to the user': 'Жеңілдіктер пайдаланушыға қолданылады',
		formatDate: 'кк.АА.жжж',
		Subscribe: 'Жазылу',
		'WebSky \nSubscription': 'WebSky\nжазылымы',
		'Your account details': 'Тіркелгіңіздің деректері',
		Plan: 'Жоспар',
		'Date of end': 'Аяқталу күні',
		'Your members': 'Сіздің қатысушыларыңыз',
		from: 'ішінен',
		Member: 'Қатысушы',
		You: 'Сіз',
		Remove: 'Жою',
		'Add member': 'Қатысушыны қосу',
		'You can add more': 'Тағы {{count}} {{member}} қосуға болады',
		'Added max number of members': 'Қатысушылардың максималды саны қосылды',
		member_0: 'қатысушы',
		member_1: 'қатысушылар',
		Payments: 'Төлемдер',
		'The next payment for your subscription will be {{date}}': 'Келесі жазылым төлемі {{date}} күтілуде',
		'Cancel auto-renewal': 'Автоматты ұзартудан бас тарту',
		'A unique subscription gives guaranteed discounts not only on your ticket, but also on tickets for your loved ones':
			'Эксклюзивті жазылым сіздің билетке ғана емес, жақын адамдарыңыздың билеттеріне де кепілдендірілген жеңілдіктер береді.',
		'The subscriber can use the privileges both separately and together with his fellow travelers, whilefellow travelers - only together with the subscriber (personal data of passengers are indicated whensubscribing and are not subject to change).':
			'Жазылушы артықшылықтарды бөлек те, сонымен қатар бағыты бір жолаушылармен бірге де, ал бағыты бір жолаушылар тек абонентпен бірге пайдалана алады (жолаушылардың жеке деректері жазылу кезінде көрсетіледі және өзгертуге жатпайды).',
		'Read more': 'Көбірек білу',
		'Get a subscription': 'Жазылымды алу',
		'Your data': 'Сіздің деректеріңіз',
		firstName: 'Аты',
		lastName: 'Тегі',
		birthDate: 'Туған күні',
		latinFirstName: 'Аты (латын әріптерімен)',
		latinLastName: 'Тегі (латын әріптерімен)',
		Required: 'Міндетті өріс',
		'Enter date in dd.mm.yyyy format': 'Күнді кк.аа.жжжж пішімінде енгізіңіз',
		'For worlds flights': 'Халықаралық ұшуларға арналған',
		'Add new Travel companion': 'Бағыты бір жаңа жолаушыны қосу',
		'Add Member': '{{member}} қосу',
		Cancel: 'Бас тарту',
		'Select from Travel companions': 'Бағыты бір жолаушыларды таңдаңыз',
		'Add new': 'Жаңасын қосу',
		'Please, select at least one member': 'Ең болмағанда бір бағыты бір жолаушыны таңдаңыз',
		'Choose your plan now': 'Тарифті таңдау',
		'You get more cost-efficient flights + greater comfort': 'Сізге тиімді қызметтер мен жайлылық беріледі',
		'Select your plan now': 'Өз тарифіңізді таңдаңыз',
		Popular: 'Танымал',
		year: 'жыл',
		Select: 'Таңдау',
		'Still have questions?': 'Сұрақтар қалды ма?'
	},
	SubsidySuggestPopup: {
		'Subsidy fares': 'Қаражаттандырылған тарифтер',
		'For special categories of passengers on the flight, you can choose special subsidy fares':
			'Бұл рейсте қаражаттандырылған тарифтер қолжетімді. Көмекқаржыны пайдалану үшін өз санатыңызды таңдаңыз',
		'A special fare is available when all passengers in an order are eligible for subsidy benefits.':
			'Көмекқаржысы бар тапсырысты рәсімдеу барлық жолаушылар оны алуға құқылы болған жағдайда ғана мүмкін болады.',
		'Apply subsidy': 'Көмекқаржыны пайдалану',
		'Continue without subsidy': 'Әдеттегі бағамен сатып алу',
		'Choose passengers': 'Санатты таңдаңыз'
	},
	Timer: {
		'Didn\'t get the code?': 'Кодты алмадыңыз ба?',
		'Resend it': 'Қайта жіберу',
		'Code sent': 'Код жіберілді',
		'You can get new code in': 'Кодты ... кейін қайта сұратуға болады',
		'Sending message': 'Кодты жібереміз'
	},
	Title: {
		companyName: 'Websky',
		'Find tickets': 'Әуе билеттерін іздеу',
		'Checkout order': 'Тапсырысты рәсімдеу',
		Payment: 'Тапсырысты төлеу',
		Account: 'Жеке кабинет'
	},
	Toolbar: {
		Total: 'Төлемге',
		Continue: 'Жалғастыру',
		Back: 'Артқа',
		'Oops...': 'Ой...',
		'An unexpected error has occurred during the creating order process. Please try again later or contact a customer support service.':
			'Тапсырысты жасау кезінде қате пайда болды. Әрекетті қайталаңыз немесе тұтынушыларға қолдау көрсету қызметіне хабарласыңыз.',
		'OK, thank you': 'Түсінікті, рақмет',
		'miles will be awared': 'осы ұшу бойынша … миль',
		'miles will be charged': 'миль есептен шығарылады',
		'This flight will be partially paid by miles': 'Бұл ұшу жартылай мильмен төленеді',
		'Fly with us and get miles': 'Бізбен бірге ұшып, миль алыңыз'
	},
	TransferInfo: {
		layover: '... ауысып отыру',
		'Change terminal': 'Терминал ауысымы',
		Terminal: 'Терминал',
		Change: 'Ауысым'
	},
	Traveller: {
		firstName: 'Аты',
		lastName: 'Тегі',
		middleName: 'Әкесінің аты',
		birthDate: 'Туған күні',
		email: 'Эл. пошта мекенжайы',
		phone: 'Телефон нөмірі',
		nationality: 'Азаматтығы',
		Add: 'Қосу',
		Required: 'Міндетті өріс',
		'Please enter a valid email': 'Дұрыс эл. пошта мекенжайын енгізіңіз',
		'Please enter a valid phone': 'Дұрыс телефон нөмірін енгізіңіз',
		'Please enter a valid date': 'Дұрыс күнді енгізіңіз',
		'FLIGHT PREFERENCES': 'ҚАЛАУЛАР',
		Seats: 'Орын',
		Meal: 'Тамақтану',
		Save: 'Сақтау',
		'Remove passengers data': 'Тізімнен жою',
		Cancel: 'Бас тарту',
		'Add companion': 'Бағыты бір жолаушыны қосу',
		'Add document': 'Құжат қосу',
		'Frequent Flyer': 'Бейілділік картасын қосыңыз',
		'Personal details': 'Тіркелгі',
		'An error occurred while executing the request, please try again':
			'Сұрауды орындау кезінде қате пайда болды, әрекетті қайталаңыз',
		Contacts: 'Контактілер',
		'With the help of this data, we will be able to inform the fellow traveler about changes in booking, flight status, check-in time, etc. Optional data.':
			'Осы деректердің көмегімен біз жолаушыға тапсырыстағы өзгерістер, тіркеудің басталуы және т.б. туралы ақпарат беретін боламыз.',
		Documents: 'Құжаттар',
		'Save the details of your internal or foreign passport, this will speed up the process of purchasing tickets.':
			'Билеттерді сатып алу процесін жеделдету үшін төлқұжат деректерін сақтаңыз'
	},
	VipServiceSelect: {
		'Different for other flight?': 'Әрбір рейс үшін бөлек реттеу',
		Cancel: 'Бас тарту',
		Confirm: 'Растау',
		Total: 'Барлығы',
		from: 'кімнен'
	},
	VisaForm: {
		applicableCountry: 'Қабылдаушы мемлекет',
		birthPlace: 'Туған жері',
		issueDate: 'Визаның берілген күні',
		issuePlace: 'Визаның берілген орны',
		number: 'Виза нөмірі',
		Required: 'Міндетті өріс',
		'format error, only latin and digits': 'Тек латын әріптері мен цифрлары',
		'only latin and digits': 'Тек латын әріптері мен цифрлары',
		'Enter date in dd.mm.yyyy format': 'Дұрыс күнді енгізіңіз',
		'Incorrect date': 'Қате күн',
		'Latin characters only': 'Тек латын әріптері'
	},
	Voucher: {
		'E-voucher': 'Промокод',
		Add: 'Қосу',
		Done: 'Дайын',
		Details: 'Толығырақ',
		'Enter code': 'Промокодты енгізіңіз'
	},
	Warnings: {
		Clarification: 'Назар аударыңыз'
	},
	translation: {
		d: 'к',
		h: 'сағ',
		m: 'м',
		s: 'с',
		kg: 'кг',
		'It looks like something went wrong': 'Бірдеңе дұрыс емес сияқты',
		'Please reload the page or start a new search': 'Бетті жаңартыңыз немесе жаңа іздеуді бастаңыз.',
		'Reload the page': 'Бетті жаңарту',
		Refresh: 'Жаңарту',
		'We couldn\'t find any flights for given dates': 'Таңдалған күндерге рейстер табылмады',
		'Unfortunately, there are no available flights for given dates or all tickets have been already sold out. Please select another date or modify your search parameters.':
			'Өкінішке орай, сіз таңдаған күндерде қолжетімді рейстер жоқ немесе барлық билеттер сатылып кетті. Іздеуді басқа күнде орындап көріңіз немесе іздеу бағытын өзгертіңіз.',
		'Please select another date or modify your search. If you wish to purchase a ticket for this particular date, please contact customer support.':
			'Басқа күнді таңдаңыз немесе іздеуді өзгертіңіз. Осы күнге билет сатып алғыңыз келсе, тұтынушыларға қолдау көрсету қызметіне хабарласыңыз.',
		'It looks like search results are obsolete': 'Бұл іздеу нәтижелері ескірген сияқты',
		'Please start a new search using the form above': 'Жоғарыдағы іздеу пішінін пайдаланып, жаңа іздеуді бастаңыз',
		'The specified cost is for all passengers and includes taxes and fees':
			'Құны салықтар мен алымдарды қоса алғанда, барлық жолаушылар үшін көрсетілген',
		'Local time': 'Жергілікті уақыт бойынша',
		'Go to main page': 'Басты бетке өту'
	}
};
